// nl strings. Every key must exist in all four tables (npm run check:i18n).
export default {
  "nav.overview": "Overzicht",
  "nav.domains": "Domeinen",
  "nav.hosting": "Hosting",
  "nav.email": "E-mail",
  "nav.backups": "Backups",
  "nav.billing": "Facturatie",
  "nav.account": "Account",
  "dash.subtitle": "Hieronder zie je in één oogopslag hoe het ervoor staat.",
  "status.allgood": "Alles werkt",
  "status.attention": "Aandacht nodig",
  "qa.title": "Snel regelen",
  "qa.domain": "Domein toevoegen",
  "qa.domain.d": "Registreer of verhuis",
  "qa.mailbox": "Mailbox aanmaken",
  "qa.mailbox.d": "Nieuw e-mailadres",
  "qa.dns": "DNS-record",
  "qa.dns.d": "Wijs door of wijzig",
  "qa.restore": "Backup terugzetten",
  "qa.restore.d": "Naar een eerder moment",
  "svc.title": "Mijn websites",
  "svc.viewall": "Alles bekijken",
  "svc.package": "Pakket",
  "svc.mailboxes": "Mailboxen",
  "svc.backup": "Laatste backup",
  "svc.manage": "Beheren",
  "svc.expires": "Volgende factuur",
  "use.title": "Gebruik",
  "use.disk": "Opslag",
  "use.traffic": "Dataverkeer",
  "use.mail": "Mailopslag",
  "use.of": "van",
  "act.title": "Recente activiteit",
  "act.viewall": "Alles bekijken",
  "next.invoice.title": "Je hebt een openstaande factuur",
  "next.invoices.title": "Je hebt openstaande facturen",
  "next.invoice.body": "Totaal openstaand: {amount}.",
  "next.overdue.body": "Totaal openstaand: {amount}. Er is een factuur over de vervaldatum.",
  "next.invoice.cta": "Bekijk facturen",
  "status.loading": "Status ophalen…",
  "status.attention.n": "{n} diensten vragen aandacht",
  "status.attention.1": "1 dienst vraagt aandacht",
  "err.network": "Geen verbinding met de server. Controleer je internetverbinding en probeer het opnieuw.",
  "err.401": "Je sessie is verlopen. Log opnieuw in.",
  "err.login.401": "Onjuist e-mailadres of wachtwoord.",
  "err.login.mfa": "Ongeldige of verlopen 2FA-code.",
  "err.403": "Je hebt geen toegang tot dit onderdeel.",
  "err.404": "Niet gevonden. Mogelijk is het verwijderd of hoort het niet bij jouw account.",
  "err.409": "Dit bestaat al of conflicteert met een bestaande instelling.",
  "err.code.quota_exceeded": "Er is niet genoeg ruimte: {quota_mb} MB past niet, er is nog {left_mb} MB vrij op {domain}.",
  "err.422": "Niet alle velden zijn juist ingevuld.",
  "err.429": "Te veel pogingen. Wacht een minuut en probeer het opnieuw.",
  "err.5xx": "Er ging iets mis aan onze kant. Probeer het later opnieuw.",
  "err.generic": "Er ging iets mis. Probeer het opnieuw.",
  "common.everything_ok": "Alles draait goed",
  "dom.title": "Domeinen",
  "dom.sub": "Beheer al je domeinnamen, DNS en doorsturingen op één plek.",
  "dom.add": "Domein toevoegen",
  "dom.search": "Zoek domein…",
  "dom.filter.all": "Alle",
  "dom.filter.active": "Actief",
  "dom.filter.expiring": "Verloopt binnenkort",
  "dom.filter.transfer": "In verhuizing",
  "dom.col.domain": "Domein",
  "dom.col.linked": "Gekoppeld aan",
  "dom.col.expires": "Verloopt",
  "dom.col.autorenew": "Auto-verleng",
  "dom.col.status": "Status",
  "dom.linked.hosting": "Hosting",
  "dom.linked.forward": "Doorsturing",
  "dom.linked.parked": "Geparkeerd",
  "dom.status.active": "Actief",
  "dom.status.expiring": "Verloopt over {n} dagen",
  "dom.status.transfer": "Verhuizing",
  "dom.add.title": "Welk domein wil je?",
  "dom.add.placeholder": "bijv. mijnbedrijf",
  "dom.add.btn": "Controleer beschikbaarheid",
  "dom.add.transfer": "Een bestaand domein verhuizen",
  "dd.back": "Alle domeinen",
  "dd.tab.overview": "Overzicht",
  "dd.tab.dns": "DNS",
  "dd.tab.email": "E-mail routering",
  "dd.tab.forward": "Doorsturen",
  "dd.tab.settings": "Instellingen",
  "dd.owner": "Eigenaar",
  "dd.registered": "Geregistreerd",
  "dd.expires": "Verloopt op",
  "dd.renew": "Verleng nu",
  "dd.autorenew": "Automatisch verlengen",
  "dd.autorenew.short": "Auto-verlengen",
  "common.yes": "Ja",
  "common.no": "Nee",
  "ar.off.title": "Automatisch verlengen uitzetten?",
  "ar.off.body": "Weet je zeker dat je dit domein niet wilt verlengen? Het domein wordt dan opgezegd en is na de verloopdatum niet meer bereikbaar.",
  "ar.off.meta": "Verloopt op",
  "ar.off.warning": "Na de verloopdatum kan het domein door iemand anders worden geregistreerd.",
  "ar.off.cancel": "Annuleren, blijf verlengen",
  "ar.off.confirm": "Ja, opzeggen",
  "host.title": "Hosting",
  "host.sub": "Je hostingpakketten, met de specs en het verbruik op één plek.",
  "host.new": "Nieuw pakket",
  "host.kpi.sites": "Actieve websites",
  "host.kpi.storage": "Opslag in gebruik",
  "host.kpi.traffic": "Dataverkeer deze maand",
  "host.banner.title": "PHP 8.3 staat klaar voor twee van je sites",
  "host.banner.body": "We hebben de upgrade alvast getest op een staging-kopie. Je kunt 'm met één klik inplannen op een rustig moment.",
  "host.banner.cta": "Upgrade plannen",
  "host.pkg.title": "Pakketten",
  "host.pkg.online": "Online",
  "host.spec.server": "Server",
  "host.spec.php": "PHP",
  "host.spec.ssl": "SSL",
  "host.spec.mailboxes": "Mailboxen",
  "host.spec.lastbackup": "Laatste backup",
  "host.usage.storage": "Opslag",
  "host.usage.traffic": "Dataverkeer",
  "host.usage.db": "Database",
  "host.manage": "Beheren",
  "host.upgrade": "Upgrade pakket",
  "host.ssl.valid": "Geldig tot",
  "host.ssl.auto": "Vernieuwt automatisch",
  "host.tools.title": "Snelle tools",
  "host.tools.files": "Bestandsbeheer",
  "host.tools.files.d": "Upload via FTP of online",
  "host.tools.db": "Database",
  "host.tools.db.d": "MySQL · phpMyAdmin",
  "host.tools.ssh": "SSH-toegang",
  "host.tools.ssh.d": "Beheer je sleutels",
  "host.tools.cron": "Cronjobs",
  "host.tools.cron.d": "Plan periodieke taken",
  "host.server.title": "Servers",
  "host.server.uptime": "Uptime 30 dagen",
  "host.server.location": "Eemshaven, NL",
  "host.summary.title": "Verbruik totaal",
  "host.summary.sub": "Over alle pakketten samen, deze maand.",
  "hd.back": "Alle pakketten",
  "hd.tab.overview": "Overzicht",
  "hd.tab.files": "Bestanden",
  "hd.tab.db": "Database",
  "hd.tab.ssh": "SSH",
  "hd.tab.cron": "Cronjobs",
  "hd.tab.settings": "Instellingen",
  "hd.kpi.uptime": "Uptime 30 dagen",
  "hd.kpi.requests": "Verzoeken vandaag",
  "hd.kpi.errors": "Fouten (24u)",
  "hd.kpi.response": "Gem. responstijd",
  "hd.deploys": "Recente deploys",
  "hd.deploys.empty": "Nog geen deploys.",
  "hd.access": "Toegangsinfo",
  "hd.access.ftp": "FTP / SFTP",
  "hd.access.ssh": "SSH",
  "hd.access.user": "Gebruiker",
  "hd.access.host": "Host",
  "hd.access.port": "Poort",
  "hd.access.path": "Webroot",
  "hd.files.upload": "Upload",
  "hd.files.new_folder": "Nieuwe map",
  "hd.files.search": "Zoek in bestanden…",
  "hd.files.col.name": "Naam",
  "hd.files.col.size": "Grootte",
  "hd.files.col.modified": "Gewijzigd",
  "hd.db.create": "Nieuwe database",
  "hd.db.open": "Open in phpMyAdmin",
  "hd.db.col.name": "Database",
  "hd.db.col.size": "Grootte",
  "hd.db.col.users": "Gebruikers",
  "hd.db.col.engine": "Engine",
  "hd.ssh.cred": "Verbindingsgegevens",
  "hd.ssh.keys": "Geautoriseerde sleutels",
  "hd.ssh.addkey": "Sleutel toevoegen",
  "hd.ssh.copy": "Kopieer commando",
  "hd.ssh.key.added": "Toegevoegd",
  "hd.cron.add": "Cronjob toevoegen",
  "hd.cron.col.schedule": "Schema",
  "hd.cron.col.cmd": "Commando",
  "hd.cron.col.last": "Laatst gedraaid",
  "hd.cron.col.status": "Status",
  "hd.set.php.title": "PHP-versie",
  "hd.set.php.sub": "Kies de PHP-versie voor dit pakket. Wijzigingen worden direct toegepast op de hele site.",
  "hd.set.php.apply": "Versie toepassen",
  "hd.set.restart.title": "Pakket herstarten",
  "hd.set.restart.sub": "Tijdelijk niet bereikbaar (~30s). Gebruik dit alleen als de site vastloopt.",
  "hd.set.restart.cta": "Herstart nu",
  "hd.set.danger.title": "Pakket opzeggen",
  "hd.set.danger.sub": "Verwijder dit pakket en alle bestanden. Niet ongedaan te maken.",
  "hd.set.danger.cta": "Pakket opzeggen",
  "hp.new.title": "Nieuw hostingpakket",
  "hp.new.sub": "Kies een pakket. Je kunt later upgraden zonder downtime.",
  "hp.new.month": "per maand",
  "hp.new.choose": "Kies dit pakket",
  "hp.new.popular": "Populair",
  "hp.new.feat.storage": "opslag",
  "hp.new.feat.traffic": "dataverkeer",
  "hp.new.feat.mail": "mailboxen",
  "hp.new.feat.db": "databases",
  "hp.new.feat.ssl": "SSL inbegrepen",
  "hp.new.feat.backup": "Dagelijkse backups",
  "hp.new.feat.ssh": "SSH-toegang",
  "hp.new.feat.staging": "Staging-omgeving",
  "ht.scope": "Voor",
  "ht.files.title": "Bestandsbeheer",
  "ht.files.sub": "Upload en beheer bestanden voor dit pakket.",
  "ht.db.title": "Databases",
  "ht.db.sub": "MySQL-databases voor dit pakket.",
  "ht.ssh.title": "SSH-toegang",
  "ht.ssh.sub": "Beheer geautoriseerde sleutels en verbindingsinstellingen.",
  "ht.cron.title": "Cronjobs",
  "ht.cron.sub": "Plan terugkerende taken die op de server draaien.",
  "act.download": "Download",
  "act.rename": "Hernoem",
  "act.move": "Verplaats",
  "act.permissions": "Rechten",
  "act.delete": "Verwijder",
  "act.open": "Open in phpMyAdmin",
  "act.export": "Exporteer (SQL-dump)",
  "act.import": "Importeer dump",
  "act.users": "Beheer gebruikers",
  "act.copy_pub": "Kopieer publieke sleutel",
  "act.revoke": "Sleutel intrekken",
  "act.run_now": "Nu uitvoeren",
  "act.edit": "Bewerk",
  "act.view_logs": "Bekijk logs",
  "act.pause": "Pauzeer",
  "act.resume": "Hervat",
  "act.duplicate": "Dupliceer",
  "act.more": "Meer acties",
  "g.cancel": "Annuleren",
  "g.save": "Opslaan",
  "g.apply": "Toepassen",
  "g.confirm": "Bevestigen",
  "mod.rename.title": "Hernoem",
  "mod.rename.label": "Nieuwe naam",
  "mod.rename.save": "Hernoem",
  "mod.move.title": "Verplaats",
  "mod.move.sub": "Kies de doelmap. Bestanden worden direct verplaatst.",
  "mod.move.current": "Huidige locatie",
  "mod.move.target": "Doelmap",
  "mod.move.save": "Verplaats",
  "mod.perm.title": "Rechten",
  "mod.perm.sub": "Kies wie wat mag met dit bestand. Direct actief.",
  "mod.perm.owner": "Eigenaar",
  "mod.perm.group": "Groep",
  "mod.perm.public": "Iedereen",
  "mod.perm.read": "Lezen",
  "mod.perm.write": "Schrijven",
  "mod.perm.exec": "Uitvoeren",
  "mod.perm.octal": "Octale waarde",
  "mod.delfile.title.file": "Bestand verwijderen?",
  "mod.delfile.title.dir": "Map verwijderen?",
  "mod.delfile.body.file": "Dit bestand wordt definitief verwijderd. Deze actie kan niet ongedaan gemaakt worden.",
  "mod.delfile.body.dir": "Deze map en alle inhoud worden definitief verwijderd. Deze actie kan niet ongedaan gemaakt worden.",
  "mod.delfile.cta": "Ja, verwijder",
  "mod.deldb.title": "Database verwijderen?",
  "mod.deldb.body": "Alle gegevens, tabellen en gebruikers gaan verloren. Deze actie kan niet ongedaan gemaakt worden.",
  "mod.deldb.confirm": "Typ de naam van de database om te bevestigen",
  "mod.deldb.cta": "Database verwijderen",
  "mod.exp.title": "Exporteer",
  "mod.exp.sub": "Maak een dump die je later kunt importeren of bewaren als backup.",
  "mod.exp.format": "Formaat",
  "mod.exp.compress": "Comprimeren (.gz)",
  "mod.exp.tables": "Tabellen",
  "mod.exp.tables.all": "Alle tabellen",
  "mod.exp.tables.pick": "Selecteer tabellen",
  "mod.exp.structure": "Structuur",
  "mod.exp.data": "Data",
  "mod.exp.start": "Start export",
  "mod.imp.title": "Importeer dump",
  "mod.imp.sub": "Upload een .sql of .sql.gz bestand. Bestaande tabellen worden overschreven.",
  "mod.imp.drop": "Sleep een bestand hierheen, of klik om te kiezen",
  "mod.imp.replace": "Bestaande tabellen overschrijven",
  "mod.imp.start": "Start import",
  "mod.imp.warn": "Een import overschrijft data. Maak eerst een export als backup.",
  "mod.dbu.title": "Gebruikers",
  "mod.dbu.sub": "Beheer welke gebruikers toegang hebben tot deze database.",
  "mod.dbu.add": "Gebruiker toevoegen",
  "mod.dbu.user": "Gebruiker",
  "mod.dbu.host": "Host",
  "mod.dbu.priv": "Rechten",
  "mod.dbu.priv.ro": "Alleen lezen",
  "mod.dbu.priv.rw": "Lezen & schrijven",
  "mod.dbu.priv.full": "Volledige toegang",
  "mod.dbu.new.user": "Gebruikersnaam",
  "mod.dbu.new.pwd": "Wachtwoord",
  "mod.dbu.new.pwd.gen": "Genereer",
  "mod.dbu.remove": "Verwijder",
  "mod.revk.title": "Sleutel intrekken?",
  "mod.revk.body": "Deze sleutel kan na intrekken niet meer inloggen op de server. Bestaande verbindingen blijven actief tot ze worden gesloten.",
  "mod.revk.cta": "Ja, trek in",
  "mod.cron.title.edit": "Cronjob bewerken",
  "mod.cron.title.new": "Nieuwe cronjob",
  "mod.cron.preset": "Schema",
  "mod.cron.preset.5min": "Elke 5 minuten",
  "mod.cron.preset.hour": "Elk uur",
  "mod.cron.preset.day": "Elke nacht 03:00",
  "mod.cron.preset.week": "Wekelijks zo 02:00",
  "mod.cron.preset.custom": "Eigen schema",
  "mod.cron.schedule": "Cron-expressie",
  "mod.cron.cmd": "Commando",
  "mod.cron.next": "Volgende uitvoering",
  "mod.clog.title": "Logs",
  "mod.clog.sub": "Laatste 30 regels van deze cronjob.",
  "mod.cdel.title": "Cronjob verwijderen?",
  "mod.cdel.body": "Deze taak draait niet meer na bevestigen. Deze actie kan niet ongedaan gemaakt worden.",
  "tst.download": "Download gestart",
  "tst.copied": "Gekopieerd naar klembord",
  "tst.renamed": "Hernoemd",
  "tst.moved": "Verplaatst",
  "tst.perm_set": "Rechten bijgewerkt",
  "tst.deleted": "Verwijderd",
  "tst.exported": "Export klaargezet",
  "tst.imported": "Import gestart",
  "tst.user_added": "Gebruiker toegevoegd",
  "tst.user_removed": "Gebruiker verwijderd",
  "tst.priv_changed": "Rechten gewijzigd",
  "tst.key_revoked": "Sleutel ingetrokken",
  "tst.cron_run": "Cronjob gestart",
  "tst.cron_duped": "Cronjob gedupliceerd",
  "tst.cron_paused": "Cronjob gepauzeerd",
  "tst.cron_resumed": "Cronjob hervat",
  "tst.cron_saved": "Cronjob opgeslagen",
  "tst.cron_deleted": "Cronjob verwijderd",
  "tst.phpmyadmin": "phpMyAdmin opent in nieuw tabblad…",
  "mod.newdir.title": "Nieuwe map",
  "mod.newdir.label": "Mapnaam",
  "mod.newdir.cta": "Maak aan",
  "tst.created": "Aangemaakt",
  "mod.newdb.title": "Nieuwe database",
  "mod.newdb.sub": "Geef de database een naam. Gebruik onderstrepen i.p.v. spaties.",
  "mod.newdb.label": "Naam",
  "mod.newdb.cta": "Database aanmaken",
  "mod.upload.title": "Bestanden uploaden",
  "mod.upload.sub": "Sleep bestanden hierheen of klik om te kiezen.",
  "mod.upload.target": "Doelmap",
  "mod.upload.start": "Upload starten",
  "mod.upload.drop": "Sleep bestanden hierheen, of klik om te kiezen",
  "tst.uploading": "Upload gestart",
  "mod.addkey.title": "SSH-sleutel toevoegen",
  "mod.addkey.sub": "Plak je publieke sleutel (begint met ssh-rsa, ssh-ed25519, …).",
  "mod.addkey.label": "Naam",
  "mod.addkey.label.placeholder": "bv. Werklaptop",
  "mod.addkey.key": "Publieke sleutel",
  "mod.addkey.cta": "Sleutel toevoegen",
  "tst.key_added": "Sleutel toegevoegd",
  "mod.upgrade.title": "Upgrade je pakket",
  "mod.upgrade.sub": "Kies een hoger pakket. Upgrade is direct actief, zonder downtime.",
  "mod.upgrade.current": "Huidig pakket",
  "mod.upgrade.cta": "Upgrade nu",
  "tst.upgraded": "Pakket bijgewerkt",
  "mod.restart.body": "De site wordt herstart en is ongeveer 30 seconden niet bereikbaar.",
  "mod.restart.cta": "Ja, herstart",
  "tst.restarting": "Herstart gestart…",
  "mod.canplan.body": "Het pakket, alle bestanden, databases en e-mails worden verwijderd. Deze actie kan niet ongedaan gemaakt worden.",
  "mod.canplan.confirm": "Typ het domein om te bevestigen",
  "tst.canceled": "Pakket opgezegd",
  "mod.phpup.title": "PHP 8.3 upgrade plannen",
  "mod.phpup.sub": "Kies wanneer we de upgrade uitvoeren. Tijdens de upgrade is je site ~10 seconden niet bereikbaar.",
  "mod.phpup.when": "Wanneer",
  "mod.phpup.when.now": "Nu uitvoeren",
  "mod.phpup.when.tonight": "Vannacht 03:00",
  "mod.phpup.when.weekend": "Komend weekend",
  "mod.phpup.sites": "Sites die geüpgraded worden",
  "mod.phpup.cta": "Plan upgrade",
  "tst.upgrade_scheduled": "Upgrade ingepland",
  "tst.php_applied": "PHP-versie toegepast",
  "em.title": "E-mail",
  "em.sub": "Beheer mailboxen, aliassen, doorsturingen en spamfilters.",
  "em.new": "Nieuw adres",
  "em.new.mailbox": "Mailbox",
  "em.new.alias": "Alias",
  "em.new.forward": "Doorsturing",
  "em.new.catchall": "Catch-all",
  "em.new.mailbox.d": "Eigen postvak met IMAP/SMTP-toegang.",
  "em.new.alias.d": "Extra adres dat in een bestaande mailbox uitkomt.",
  "em.new.forward.d": "Mail doorsturen naar een extern adres.",
  "em.new.catchall.d": "Vang alle mail naar dit domein op één plek op.",
  "em.new.helper": "Wat wil je aanmaken?",
  "em.new.target": "Bezorg in",
  "em.new.forward_to": "Stuur naar",
  "em.search": "Zoek mailbox of alias…",
  "em.filter.all": "Alle",
  "em.filter.mailbox": "Mailboxen",
  "em.filter.alias": "Aliassen",
  "em.filter.forward": "Doorsturingen",
  "em.kpi.mailboxes": "Actieve mailboxen",
  "em.kpi.storage": "Mailopslag",
  "em.kpi.spam": "Spam geblokkeerd (24u)",
  "em.kpi.delivered": "Bezorgd vandaag",
  "em.col.address": "Adres",
  "em.col.type": "Type",
  "em.col.usage": "Gebruik",
  "em.col.last": "Laatst ingelogd",
  "em.col.status": "Status",
  "em.type.mailbox": "Mailbox",
  "em.type.alias": "Alias",
  "em.type.forward": "Doorsturing",
  "em.type.catchall": "Catch-all",
  "em.status.active": "Actief",
  "em.status.full": "Bijna vol",
  "em.status.vacation": "Vakantie",
  "em.status.paused": "Gepauzeerd",
  "em.group.by_domain": "Per domein",
  "em.group.flat": "Platte lijst",
  "em.banner.title": "Spam-bescherming staat aan",
  "em.banner.body": "We blokkeerden deze week 1.284 berichten voor je domeinen. Geen actie nodig.",
  "em.banner.cta": "Spam-instellingen",
  "ed.back": "Alle mailboxen",
  "ed.tab.overview": "Overzicht",
  "ed.tab.filters": "Filters",
  "ed.tab.forward": "Doorsturen",
  "ed.tab.vacation": "Vakantie",
  "ed.tab.aliases": "Aliassen",
  "ed.tab.settings": "Instellingen",
  "ed.kpi.in": "Inkomend vandaag",
  "ed.kpi.out": "Verzonden vandaag",
  "ed.kpi.spam": "Spam",
  "ed.kpi.bounce": "Bounces",
  "ed.webmail": "Open webmail",
  "ed.changepwd": "Wachtwoord wijzigen",
  "ed.access.title": "Toegangsinfo",
  "ed.access.imap": "IMAP",
  "ed.access.smtp": "SMTP",
  "ed.access.host": "Host",
  "ed.access.port": "Poort",
  "ed.access.user": "Gebruiker",
  "ed.access.security": "Beveiliging",
  "ed.recent.title": "Recente activiteit",
  "ed.recent.empty": "Geen activiteit in de laatste 7 dagen.",
  "ed.devices.title": "Aangemelde apparaten",
  "ed.devices.logout": "Loguit",
  "ef.title": "Filters",
  "ef.sub": "Berichten automatisch verplaatsen, markeren of weggooien.",
  "ef.add": "Filter toevoegen",
  "ef.col.name": "Naam",
  "ef.col.when": "Wanneer",
  "ef.col.then": "Doe dit",
  "ef.empty.title": "Nog geen filters",
  "ef.empty.sub": "Maak je eerste filter, bijvoorbeeld: stuur alles van bookings@ naar de map Boekingen.",
  "ef.cond.from": "Afzender bevat",
  "ef.cond.subject": "Onderwerp bevat",
  "ef.cond.to": "Aan bevat",
  "ef.cond.body": "Bericht bevat",
  "ef.act.folder": "Verplaats naar map",
  "ef.act.label": "Voeg label toe",
  "ef.act.flag": "Markeer belangrijk",
  "ef.act.delete": "Direct verwijderen",
  "ef.act.forward": "Doorsturen naar",
  "evf.title": "Doorsturen",
  "evf.sub": "Inkomende mail automatisch naar een ander adres sturen.",
  "evf.on": "Doorsturen aan",
  "evf.to": "Naar",
  "evf.keep": "Behoud kopie in deze mailbox",
  "evf.add_to": "Voeg adres toe",
  "evf.empty": "Voeg minstens één adres toe om door te sturen.",
  "ev.title": "Vakantieantwoord",
  "ev.sub": "Stuur automatisch een antwoord wanneer je niet beschikbaar bent.",
  "ev.on": "Vakantieantwoord aan",
  "ev.from": "Van",
  "ev.until": "Tot",
  "ev.subject": "Onderwerp",
  "ev.message": "Bericht",
  "ev.once": "Eén keer per afzender",
  "ea.title": "Aliassen",
  "ea.sub": "Extra adressen die in deze mailbox uitkomen.",
  "ea.add": "Alias toevoegen",
  "ea.col.alias": "Alias",
  "ea.col.target": "Komt uit in",
  "ea.empty.title": "Geen aliassen",
  "ea.empty.sub": "Maak bijvoorbeeld info@ of contact@ als alias voor deze mailbox.",
  "es.title": "Instellingen",
  "es.quota.title": "Opslaglimiet",
  "es.quota.sub": "Maximale grootte voor deze mailbox.",
  "es.spam.title": "Spamfilter",
  "es.spam.sub": "Bepaal hoe streng we spam moeten filteren.",
  "es.spam.strict": "Streng",
  "es.spam.balanced": "Gebalanceerd",
  "es.spam.lenient": "Soepel",
  "es.smtp.title": "Externe SMTP toestaan",
  "es.smtp.sub": "Verzenden via deze mailbox vanaf externe apparaten.",
  "es.danger.title": "Mailbox verwijderen",
  "es.danger.sub": "Verwijder deze mailbox en alle berichten. Niet ongedaan te maken.",
  "es.danger.cta": "Verwijder mailbox",
  "mod.nm.title": "Nieuwe mailbox",
  "mod.nm.sub": "Maak een mailbox aan voor één van je domeinen.",
  "mod.nm.local": "Adres",
  "mod.nm.domain": "Domein",
  "mod.nm.pwd": "Wachtwoord",
  "mod.nm.pwd.gen": "Genereer",
  "mod.nm.quota": "Opslaglimiet",
  "mod.nm.cta": "Mailbox aanmaken",
  "mod.pwd.title": "Wachtwoord wijzigen",
  "mod.pwd.sub": "Het nieuwe wachtwoord werkt direct. Aangemelde clients moeten opnieuw inloggen.",
  "mod.pwd.new": "Nieuw wachtwoord",
  "mod.pwd.confirm": "Bevestig wachtwoord",
  "mod.pwd.show": "Toon",
  "mod.pwd.hide": "Verberg",
  "mod.pwd.cta": "Wachtwoord opslaan",
  "mod.pwd.mismatch": "Wachtwoorden komen niet overeen.",
  "mod.pwd.weak": "Wachtwoord is te zwak. Gebruik minstens 10 tekens.",
  "mod.alias.title": "Alias toevoegen",
  "mod.alias.sub": "Maak een nieuw adres dat in deze mailbox uitkomt.",
  "mod.alias.local": "Alias",
  "mod.alias.domain": "Domein",
  "mod.alias.cta": "Alias aanmaken",
  "mod.efilter.title.edit": "Filter bewerken",
  "mod.efilter.title.new": "Nieuwe filter",
  "mod.efilter.name": "Naam",
  "mod.efilter.if": "Als",
  "mod.efilter.value": "Waarde",
  "mod.efilter.then": "Doe dit",
  "mod.efilter.cta": "Filter opslaan",
  "mod.delmb.title": "Mailbox verwijderen?",
  "mod.delmb.body": "Alle berichten gaan verloren. Deze actie kan niet ongedaan gemaakt worden.",
  "mod.delmb.confirm": "Typ het adres om te bevestigen",
  "mod.delmb.cta": "Mailbox verwijderen",
  "eact.webmail": "Open webmail",
  "eact.pwd": "Wachtwoord wijzigen",
  "eact.forward": "Doorsturen instellen",
  "eact.vacation": "Vakantie aanzetten",
  "eact.alias": "Alias toevoegen",
  "eact.pause": "Pauzeer mailbox",
  "eact.resume": "Hervat mailbox",
  "eact.delete": "Verwijder",
  "tst.mb_created": "Mailbox aangemaakt",
  "tst.mb_deleted": "Mailbox verwijderd",
  "tst.pwd_changed": "Wachtwoord gewijzigd",
  "tst.alias_added": "Alias toegevoegd",
  "tst.alias_removed": "Alias verwijderd",
  "tst.filter_saved": "Filter opgeslagen",
  "tst.filter_deleted": "Filter verwijderd",
  "tst.vacation_on": "Vakantieantwoord aangezet",
  "tst.vacation_off": "Vakantieantwoord uitgezet",
  "tst.forward_on": "Doorsturen ingeschakeld",
  "tst.forward_off": "Doorsturen uitgeschakeld",
  "tst.mb_paused": "Mailbox gepauzeerd",
  "tst.mb_resumed": "Mailbox hervat",
  "tst.webmail": "Webmail opent in nieuw tabblad…",
  "mod.edit_alias.title.alias": "Alias bewerken",
  "mod.edit_alias.title.forward": "Doorsturing bewerken",
  "mod.edit_alias.title.catchall": "Catch-all bewerken",
  "mod.edit_alias.from": "Adres",
  "mod.edit_alias.to": "Komt uit in",
  "mod.edit_alias.to.external": "Stuur door naar",
  "tst.edited": "Bijgewerkt",
  "spam.title": "Spam-instellingen",
  "spam.sub": "Hoe streng filteren we spam voor al je domeinen?",
  "spam.level": "Filterniveau",
  "spam.lvl.strict": "Streng",
  "spam.lvl.strict.d": "Alles met de minste twijfel wordt geblokkeerd. Soms vals positief.",
  "spam.lvl.balanced": "Gebalanceerd",
  "spam.lvl.balanced.d": "Onze aanbeveling. Spam in spam-map, twijfel doorlaten met label.",
  "spam.lvl.lenient": "Soepel",
  "spam.lvl.lenient.d": "Alleen overduidelijke spam blokkeren. Meer in je inbox, ook spam.",
  "spam.greylist": "Greylisting",
  "spam.greylist.d": "Stuur onbekende verzenders één keer terug. Effectief tegen bots; iets vertraagd bezorgen.",
  "spam.blocklist": "Blokkeerlijst",
  "spam.blocklist.add": "Adres of domein toevoegen",
  "spam.allowlist": "Toestaan",
  "spam.allowlist.add": "Adres of domein toevoegen",
  "spam.scope": "Geldt voor",
  "spam.scope.all": "Alle domeinen",
  "spam.scope.pick": "Per domein",
  "tst.spam_saved": "Spam-instellingen opgeslagen",
  "mod.devlogout.title": "Apparaat afmelden?",
  "mod.devlogout.body": "Het apparaat moet opnieuw inloggen om weer bij deze mailbox te komen.",
  "mod.devlogout.cta": "Ja, log uit",
  "tst.dev_logged_out": "Apparaat afgemeld",
  "bk.title": "Backups",
  "bk.sub": "Automatische dagelijkse backups voor al je sites en mailboxen. Snel terug naar elk eerder moment.",
  "bk.new": "Nu backup maken",
  "bk.schedule": "Schema bewerken",
  "bk.kpi.last": "Laatste backup",
  "bk.kpi.success": "Succesvol (30d)",
  "bk.kpi.storage": "Backup-opslag",
  "bk.kpi.retention": "Bewaartermijn",
  "bk.banner.title": "Alles draait. Backups gisteren 04:12 voltooid.",
  "bk.banner.body": "3 sites en 9 mailboxen succesvol veiliggesteld. Geen actie nodig.",
  "bk.banner.cta": "Activiteitenlog",
  "bk.list.title": "Per site",
  "bk.col.site": "Site",
  "bk.col.last": "Laatste backup",
  "bk.col.snapshots": "Snapshots",
  "bk.col.size": "Grootte",
  "bk.col.next": "Volgende backup",
  "bk.col.status": "Status",
  "bk.status.healthy": "Gezond",
  "bk.status.warn": "Aandacht nodig",
  "bk.status.running": "Bezig",
  "bk.snapshots.title": "Snapshots",
  "bk.snapshots.sub": "Elk snapshot bevat bestanden, databases en mailboxen op dat moment.",
  "bk.snap.col.when": "Wanneer",
  "bk.snap.col.kind": "Type",
  "bk.snap.col.size": "Grootte",
  "bk.snap.col.includes": "Inhoud",
  "bk.snap.col.retention": "Bewaard tot",
  "bk.snap.kind.daily": "Dagelijks",
  "bk.snap.kind.weekly": "Wekelijks",
  "bk.snap.kind.monthly": "Maandelijks",
  "bk.snap.kind.manual": "Handmatig",
  "bk.snap.kind.predeploy": "Voor deploy",
  "bk.tab.snapshots": "Snapshots",
  "bk.tab.settings": "Instellingen",
  "bk.tab.activity": "Activiteit",
  "bk.act.restore": "Herstel",
  "bk.act.download": "Download (.zip)",
  "bk.act.contents": "Bekijk inhoud",
  "bk.act.lock": "Bewaren langer",
  "bk.act.unlock": "Niet langer bewaren",
  "bk.act.delete": "Verwijder snapshot",
  "bk.set.freq.title": "Frequentie",
  "bk.set.freq.sub": "Hoe vaak maken we automatisch een backup.",
  "bk.set.freq.hourly": "Elk uur",
  "bk.set.freq.daily": "Dagelijks",
  "bk.set.freq.twice": "2x per dag",
  "bk.set.ret.title": "Bewaartermijn",
  "bk.set.ret.sub": "Hoe lang bewaren we elk type snapshot.",
  "bk.set.ret.daily": "Dagelijkse",
  "bk.set.ret.weekly": "Wekelijkse",
  "bk.set.ret.monthly": "Maandelijkse",
  "bk.set.scope.title": "Wat zit in een backup",
  "bk.set.scope.sub": "Schakel onderdelen uit als je ergens minder ruimte aan wilt geven.",
  "bk.set.scope.files": "Bestanden",
  "bk.set.scope.db": "Databases",
  "bk.set.scope.mail": "Mailboxen",
  "bk.set.offsite.title": "Off-site replicatie",
  "bk.set.offsite.sub": "Tweede kopie in een ander datacenter (Eemshaven → Groningen).",
  "bk.includes.files": "Bestanden",
  "bk.includes.db": "Databases",
  "bk.includes.mail": "Mailboxen",
  "bk.activity.title": "Activiteit",
  "bk.activity.empty": "Nog geen activiteit deze week.",
  "mod.restore.title": "Herstel snapshot",
  "mod.restore.sub": "Kies wat je terug wilt zetten en waarheen. We maken eerst nog een veiligheids-snapshot.",
  "mod.restore.what": "Wat herstellen",
  "mod.restore.what.all": "Alles",
  "mod.restore.what.files": "Alleen bestanden",
  "mod.restore.what.db": "Alleen databases",
  "mod.restore.what.mail": "Alleen mailboxen",
  "mod.restore.where": "Waarheen",
  "mod.restore.where.live": "Terug naar live site",
  "mod.restore.where.staging": "Naar staging-omgeving",
  "mod.restore.dry": "Dry-run: laat zien wat zou veranderen, voer niks uit",
  "mod.restore.cta": "Start herstel",
  "mod.restore.warn": "Het herstel overschrijft de huidige bestanden en databases. Maak van te voren een handmatige backup als je het zekere wilt.",
  "mod.restore.files.title": "Bestanden",
  "mod.restore.files.all": "Alle bestanden",
  "mod.restore.files.pick": "Selecteer mappen",
  "mod.restore.files.hint": "Vink mappen/bestanden aan om alleen die terug te zetten.",
  "mod.restore.db.title": "Databases",
  "mod.restore.db.all": "Alle databases",
  "mod.restore.db.pick": "Selecteer databases",
  "mod.restore.mail.title": "Mailboxen",
  "mod.restore.mail.all": "Alle mailboxen",
  "mod.restore.mail.pick": "Selecteer mailboxen",
  "mod.restore.where.sub": "Naar subdomein",
  "mod.restore.sub.label": "Subdomein",
  "mod.restore.sub.help": "We zetten het snapshot terug op een tijdelijke kopie. Je live site blijft onveranderd.",
  "mod.restore.sub.preview": "Wordt bereikbaar op",
  "mod.restore.summary": "Wordt teruggezet",
  "mod.restore.summary.empty": "Selecteer minimaal één onderdeel hierboven.",
  "mod.bnow.title": "Nu een backup maken",
  "mod.bnow.sub": "Maak handmatig een momentopname. Handig vóór een grote update.",
  "mod.bnow.scope": "Wat opnemen",
  "mod.bnow.label": "Label (optioneel)",
  "mod.bnow.label.ph": "bv. Voor PHP 8.3 upgrade",
  "mod.bnow.lock": "Niet automatisch opruimen",
  "mod.bnow.cta": "Backup starten",
  "mod.snap.title": "Inhoud van snapshot",
  "mod.snap.files": "Bestanden",
  "mod.snap.db": "Databases",
  "mod.snap.mail": "Mailboxen",
  "mod.snap.size": "Grootte",
  "mod.snap.count": "Aantal",
  "mod.snap.kind": "Type",
  "mod.snap.created": "Gemaakt",
  "mod.delsnap.title": "Snapshot verwijderen?",
  "mod.delsnap.body": "Het snapshot wordt direct verwijderd. Andere snapshots blijven beschikbaar.",
  "tst.backup_started": "Backup gestart",
  "tst.backup_done": "Backup voltooid",
  "tst.restore_started": "Herstel gestart",
  "tst.snapshot_locked": "Snapshot vastgepind",
  "tst.snapshot_unlocked": "Snapshot vrijgegeven",
  "tst.snapshot_deleted": "Snapshot verwijderd",
  "tst.schedule_saved": "Schema opgeslagen",
  "bl.title": "Facturatie",
  "bl.sub": "Facturen, betaalmethoden en abonnementen op één plek.",
  "bl.pay": "Betaal openstaand",
  "bl.pay_method": "Betaalmethode wijzigen",
  "bl.address": "Factuuradres",
  "bl.kpi.open": "Openstaand",
  "bl.kpi.this_month": "Deze maand",
  "bl.kpi.next": "Volgende factuur",
  "bl.kpi.method": "Betaalmethode",
  "bl.banner.title": "Bespaar 5% met SEPA-incasso",
  "bl.banner.body": "We schrijven automatisch af op de vervaldatum. Stap met één klik over.",
  "bl.banner.cta": "Activeer incasso",
  "bl.invoices.title": "Recente facturen",
  "bl.invoices.viewall": "Alles bekijken",
  "bl.col.number": "Factuurnummer",
  "bl.col.date": "Datum",
  "bl.col.amount": "Bedrag",
  "bl.col.due": "Vervaldatum",
  "bl.col.status": "Status",
  "bl.status.paid": "Betaald",
  "bl.status.open": "Openstaand",
  "bl.status.overdue": "Te laat",
  "bl.status.draft": "Concept",
  "bl.subs.title": "Abonnementen",
  "bl.subs.cancel": "Opzeggen",
  "bl.subs.viewall": "Beheer abonnementen",
  "bl.methods.title": "Betaalmethoden",
  "bl.methods.add": "Methode toevoegen",
  "bl.methods.primary": "Primair",
  "bl.methods.set_primary": "Maak primair",
  "bl.methods.remove": "Verwijder",
  "bl.address.title": "Factuuradres",
  "bl.address.edit": "Bewerk",
  "bd.back": "Alle facturen",
  "bd.invoice": "Factuur",
  "bd.items.title": "Specificatie",
  "bd.items.col.desc": "Omschrijving",
  "bd.items.col.period": "Periode",
  "bd.items.col.qty": "Aantal",
  "bd.items.col.price": "Stukprijs",
  "bd.items.col.amount": "Bedrag",
  "bd.items.subtotal": "Subtotaal",
  "bd.items.vat": "BTW (21%)",
  "bd.items.total": "Totaal",
  "bd.actions.download": "Download PDF",
  "bd.actions.send": "Stuur kopie",
  "bd.actions.print": "Print",
  "bd.actions.pay": "Betaal nu",
  "bd.history.title": "Tijdlijn",
  "bd.notes.title": "Notities",
  "bd.notes.empty": "Geen notities op deze factuur.",
  "mod.pay.title": "Factuur betalen",
  "mod.pay.sub": "Kies een betaalmethode. Het bedrag wordt direct verrekend.",
  "mod.pay.amount": "Bedrag",
  "mod.pay.method": "Methode",
  "mod.pay.cta": "Betaal nu",
  "mod.pm.title": "Betaalmethode toevoegen",
  "mod.pm.sub": "Kies een betaalmethode. We slaan deze veilig op voor herhaalbetalingen.",
  "mod.pm.kind": "Type",
  "mod.pm.kind.ideal": "iDEAL",
  "mod.pm.kind.card": "Creditcard",
  "mod.pm.kind.sepa": "SEPA-incasso",
  "mod.pm.bank": "Bank",
  "mod.pm.iban": "IBAN",
  "mod.pm.holder": "Naam op rekening",
  "mod.pm.card.num": "Kaartnummer",
  "mod.pm.card.exp": "Vervaldatum",
  "mod.pm.card.cvc": "CVC",
  "mod.pm.cta": "Methode toevoegen",
  "mod.pm.set_primary": "Maak primaire methode",
  "mod.addr.title": "Factuuradres bewerken",
  "mod.addr.company": "Bedrijf",
  "mod.addr.attn": "T.a.v.",
  "mod.addr.street": "Adres",
  "mod.addr.zip": "Postcode",
  "mod.addr.city": "Plaats",
  "mod.addr.country": "Land",
  "mod.addr.vat": "BTW-nummer",
  "mod.addr.email": "E-mail voor facturen",
  "mod.addr.cta": "Opslaan",
  "mod.canceluse.title": "Abonnement opzeggen?",
  "mod.canceluse.body": "Het abonnement loopt door tot het einde van de huidige periode. Daarna wordt het pakket gedeactiveerd.",
  "mod.canceluse.cta": "Ja, zeg op",
  "tst.invoice_paid": "Factuur betaald",
  "tst.payment_started": "Betaling gestart",
  "tst.method_added": "Methode toegevoegd",
  "tst.method_removed": "Methode verwijderd",
  "tst.method_primary": "Primaire methode ingesteld",
  "tst.address_saved": "Adres opgeslagen",
  "tst.subscription_canceled": "Abonnement opgezegd",
  "tst.invoice_sent": "Factuur verstuurd",
  "tst.print": "Printvenster opent…",
  "dd.nameservers": "Nameservers",
  "dd.lock": "Verhuisbescherming",
  "dd.linked.title": "Gekoppelde diensten",
  "dns.simple": "Simpele modus",
  "dns.advanced": "Geavanceerd",
  "dns.tasks.title": "Wat wil je doen?",
  "dns.tasks.sub": "Kies een veelvoorkomende taak en wij regelen de DNS-records voor je.",
  "dns.task.website": "Wijs naar mijn website",
  "dns.task.website.d": "Stel A- en CNAME-records in zodat bezoekers op je website terechtkomen.",
  "dns.task.mail": "Mijn e-mail loopt via…",
  "dns.task.mail.d": "Configureer MX-records voor Google Workspace, Microsoft 365 of DMRS Mail.",
  "dns.task.verify": "Verifieer een dienst",
  "dns.task.verify.d": "Plaats een TXT-record om eigendom aan te tonen (Google, Meta, …).",
  "dns.task.forward": "Stuur naar een andere URL",
  "dns.task.forward.d": "Bezoekers van dit domein doorsturen naar bijvoorbeeld example.com.",
  "dns.records.title": "Alle DNS-records",
  "dns.records.add": "Record toevoegen",
  "dns.records.help": "Niet zeker? Gebruik de simpele modus hierboven.",
  "dns.col.type": "Type",
  "dns.col.name": "Naam",
  "dns.col.value": "Waarde",
  "dns.col.ttl": "TTL",
  "tw.title": "Wijs {domain} naar je website",
  "tw.sub": "Kies waar je website draait. Wij regelen de juiste DNS-records.",
  "tw.opt.dmrs": "DMRS Hosting (deze klant)",
  "tw.opt.ip": "Een ander IP-adres",
  "tw.opt.host": "Een andere hostnaam (bijv. mijnsite.netlify.app)",
  "tw.cancel": "Annuleer",
  "tw.apply": "Pas toe",
  "tw.preview": "Wij maken deze records aan:",
  "mr.title": "E-mail routering",
  "mr.sub": "Bepaal welke server de e-mail voor dit domein ontvangt.",
  "mr.current": "Huidige instelling",
  "mr.change": "Wijzig provider",
  "mr.preset.dmrs": "DMRS Mail",
  "mr.preset.dmrs.d": "Inbegrepen bij je hostingpakket. 6 mailboxen actief.",
  "mr.preset.google": "Google Workspace",
  "mr.preset.google.d": "Gmail voor je domein. Je hebt een Workspace-account nodig.",
  "mr.preset.ms": "Microsoft 365",
  "mr.preset.ms.d": "Outlook voor je domein. Je hebt een M365-account nodig.",
  "mr.preset.none": "Geen e-mail",
  "mr.preset.none.d": "Ontvang geen e-mail op dit domein. Verwijdert MX-records.",
  "mr.preset.custom": "Andere provider",
  "mr.preset.custom.d": "Voer eigen MX-records in (bijv. Fastmail, ProtonMail).",
  "mr.deliverability": "Afleverbaarheid",
  "mr.spf": "SPF",
  "mr.dkim": "DKIM",
  "mr.dmarc": "DMARC",
  "mr.healthy": "Goed ingesteld",
  "fw.title": "Doorsturen",
  "fw.sub": "Stuur bezoekers automatisch door naar een andere URL.",
  "fw.add": "Doorsturing toevoegen",
  "fw.col.from": "Van",
  "fw.col.to": "Naar",
  "fw.col.type": "Type",
  "fw.col.code": "Statuscode",
  "fw.type.permanent": "Permanent",
  "fw.type.temporary": "Tijdelijk",
  "fw.empty.title": "Nog geen doorsturingen",
  "fw.empty.sub": "Stuur bijvoorbeeld het hele domein door naar een ander adres, of /blog naar je Medium.",
  "ds.title": "Instellingen",
  "ds.sub": "Contactgegevens, nameservers en domeinverhuizing.",
  "ds.contact.title": "Contactgegevens",
  "ds.contact.sub": "Worden gebruikt voor WHOIS en officiële berichten van de registry.",
  "ds.contact.edit": "Bewerk contacten",
  "ds.ns.title": "Nameservers",
  "ds.ns.sub": "Standaard staan ze op DMRS nameservers. Verander alleen als je weet wat je doet.",
  "ds.ns.use_dmrs": "Gebruik DMRS nameservers",
  "ds.ns.custom": "Eigen nameservers",
  "ds.danger.title": "Domein verhuizen",
  "ds.danger.sub": "Vraag een verhuiscode op om dit domein bij een andere registrar onder te brengen.",
  "ds.danger.get": "Verhuiscode aanvragen",
  "ds.dnssec.title": "DNSSEC",
  "ds.dnssec.sub": "Beveiligt DNS-antwoorden tegen vervalsing. Aanbevolen.",
  "ds.dnssec.active": "DNSSEC actief",
  "ds.dnssec.algo": "Algoritme",
  "ds.dnssec.keytag": "Key tag",
  "ds.dnssec.ds": "DS-record",
  "ds.dnssec.keys.title": "Eigen DS-records",
  "ds.dnssec.keys.sub": "Voeg de DS-records van je externe DNS-provider toe.",
  "ds.dnssec.keys.add": "DS-record toevoegen",
  "ds.dnssec.keys.empty": "Nog geen eigen DS-records. DMRS beheert de keys.",
  "mod.dnssec.title": "DS-record toevoegen",
  "mod.dnssec.keytag": "Key tag",
  "mod.dnssec.algo": "Algoritme",
  "mod.dnssec.digestType": "Digest-type",
  "mod.dnssec.digest": "Digest",
  "mod.dnssec.cta": "DS-record toevoegen",
  "tst.ds_added": "DS-record toegevoegd",
  "tst.ds_removed": "DS-record verwijderd",
  "mod.contacts.title": "Contacten bewerken",
  "mod.contacts.sub": "Houder en technisch contact worden gebruikt voor WHOIS en officiële berichten van de registry.",
  "mod.contacts.role.holder": "Houder",
  "mod.contacts.role.tech": "Technisch contact",
  "mod.contacts.role.admin": "Administratief contact",
  "mod.contacts.role.billing": "Facturatie contact",
  "mod.contacts.name": "Naam",
  "mod.contacts.email": "E-mail",
  "mod.contacts.phone": "Telefoon",
  "mod.contacts.handle": "Handle",
  "mod.contacts.handle.ph": "bv. JANS001",
  "mod.contacts.handle.search": "Zoek handle",
  "mod.contacts.handle.searching": "Bezig met zoeken…",
  "mod.contacts.handle.notfound": "Geen handle gevonden — vul handmatig in.",
  "mod.contacts.handle.help": "Registry-handle van dit contact. Wordt later automatisch opgehaald.",
  "tst.contacts_saved": "Contacten opgeslagen",
  "mod.transfer.method": "Code ontvangen via",
  "mod.transfer.method.email": "Beveiligde e-mail",
  "mod.transfer.method.sms": "Sms naar geregistreerd nummer",
  "mod.transfer.method.email.d": "We sturen de code naar je houder-adres. Verstandig: niet zichtbaar in het paneel.",
  "mod.transfer.dnssec.title": "Zet eerst DNSSEC uit",
  "mod.transfer.dnssec.body": "Veel verhuizingen mislukken omdat DNSSEC bij de oude registrar nog actief is. Schakel het hier uit zodat de nieuwe registrar het opnieuw kan instellen.",
  "mod.transfer.dnssec.cta": "Zet DNSSEC uit",
  "mod.transfer.dnssec.skip": "Laat DNSSEC aan",
  "mod.transfer.send": "Stuur verhuiscode",
  "tst.transfer_sent": "Verhuiscode verstuurd naar je e-mail",
  "ds.ns.save": "Nameservers opslaan",
  "ds.ns.invalid": "Voer minstens 2 geldige nameservers in.",
  "mod.ns.title": "Nameservers wijzigen?",
  "mod.ns.body": "Een wijziging kan tot 24u duren voor hij wereldwijd actief is. Tijdens deze periode kan je site of e-mail tijdelijk onbereikbaar zijn.",
  "mod.ns.cta": "Ja, wijzig nameservers",
  "tst.ns_saved": "Nameservers opgeslagen",
  "tst.dnssec_on": "DNSSEC aangezet",
  "tst.dnssec_off": "DNSSEC uitgezet",
  "mod.transfer.title": "Verhuiscode aanvragen",
  "mod.transfer.sub": "Geef deze code aan je nieuwe registrar om dit domein bij hen onder te brengen.",
  "mod.transfer.code": "Verhuiscode",
  "mod.transfer.warn": "Zodra de verhuizing is gestart, kan je hier geen wijzigingen meer doen. Annuleer eventuele lopende wijzigingen eerst.",
  "mod.transfer.copy": "Kopieer code",
  "mod.transfer.email": "Stuur naar mijn e-mail",
  "tst.transfer_code": "Verhuiscode opnieuw aangemaakt",
  "mm.title": "Mijn e-mail loopt via…",
  "mm.sub": "Kies je e-mailprovider. We zetten de juiste MX-records voor je klaar.",
  "mm.confirm": "MX-records nu vervangen",
  "vm.title": "Verifieer een dienst",
  "vm.sub": "Veel diensten vragen je een TXT-record toe te voegen om aan te tonen dat dit domein van jou is.",
  "vm.svc": "Welke dienst?",
  "vm.token": "Verificatiecode",
  "vm.token.placeholder": "Plak hier de code uit Google Search Console of een andere dienst",
  "vm.create": "TXT-record aanmaken",
  "fwm.title": "Stuur naar een andere URL",
  "fwm.from": "Van (dit domein)",
  "fwm.to": "Naar (volledige URL)",
  "fwm.kind.full": "Hele domein",
  "fwm.kind.path": "Specifiek pad",
  "fwm.kind.title": "Wat wil je doorsturen?",
  "fwm.code": "Statuscode",
  "fwm.code.301": "301 — Permanent (aanbevolen)",
  "fwm.code.302": "302 — Tijdelijk",
  "fwm.create": "Doorsturing aanmaken",
  "rec.add.title": "DNS-record toevoegen",
  "rec.edit.title": "DNS-record bewerken",
  "rec.type": "Type",
  "rec.name": "Naam",
  "rec.name.help": "Gebruik @ voor het hoofddomein. Bijv. www, mail of api.",
  "rec.value": "Waarde",
  "rec.value.help.A": "Een IPv4-adres, bijv. 185.182.56.42",
  "rec.value.help.AAAA": "Een IPv6-adres, bijv. 2a01:7c8::1",
  "rec.value.help.CNAME": "Een hostnaam waar dit op moet verwijzen, eindigend op een punt of niet.",
  "rec.value.help.MX": "Prioriteit (laag = belangrijker) gevolgd door de mailserver, bijv. 10 mail.dmrs.nl",
  "rec.value.help.TXT": "Vrije tekst, vaak gebruikt voor verificatie en mail (SPF, DKIM, DMARC).",
  "rec.value.help.SRV": "Prioriteit, gewicht, poort en doel — bijv. 10 100 443 sip.example.com",
  "rec.ttl": "TTL (seconden)",
  "rec.ttl.help": "Hoe lang andere servers dit record mogen cachen. 3600 (1 uur) is standaard.",
  "rec.prio": "Prioriteit",
  "rec.save": "Opslaan",
  "rec.delete": "Record verwijderen",
  "rec.delete.confirm": "Weet je zeker dat je dit record wilt verwijderen?",
  "common.loading": "Bezig met laden…",
  "format.justNow": "zojuist",
  "format.perMonth": "{amount}/mnd",
  "invoiceStatus.paid": "Betaald",
  "invoiceStatus.open": "Open",
  "invoiceStatus.overdue": "Te laat",
  "invoiceStatus.failed": "Betaling mislukt",
  "invoiceStatus.cancelled": "Geannuleerd",
  "hostingStatus.active": "Actief",
  "hostingStatus.suspended": "Opgeschort",
  "hostingStatus.terminated": "Beëindigd",
  "hostingStatus.pending": "Wordt ingericht",
  "hostingStatus.pending_cancellation": "Opgezegd",
  "health.healthy": "Online",
  "health.degraded": "Verstoord",
  "health.down": "Offline",
  "health.unknown": "Actief",
  "health.checked": "Gecontroleerd {time}",
  "notif.invoice.overdue": "Factuur {number} is verlopen",
  "notif.invoice.failed": "Betaling van {number} mislukt",
  "notif.invoice.open": "Factuur {number} staat open",
  "notif.invoice.body": "{amount} · vervalt {date}",
  "notif.hosting.suspended": "{domain} is opgeschort",
  "notif.hosting.suspended.body": "Neem contact op of betaal openstaande facturen.",
  "notif.hosting.pending": "{domain} wordt ingericht",
  "notif.hosting.pending.body": "We laten het weten zodra de hosting klaarstaat.",
  "notif.hosting.down": "{domain} is niet bereikbaar",
  "notif.hosting.down.body": "We zijn ermee bezig. Bekijk de details bij de hosting.",
  "domainError.empty": "Vul een domeinnaam in.",
  "domainError.url": "Vul alleen de domeinnaam in, zonder http:// of een pad (bijv. voorbeeld.nl).",
  "domainError.email": "Dit lijkt een e-mailadres. Vul alleen de domeinnaam in.",
  "domainError.space": "Een domeinnaam mag geen spaties bevatten.",
  "domainError.www": "Laat \"www.\" weg; dat regelen we automatisch.",
  "domainError.no_tld": "Voeg de extensie toe, bijvoorbeeld .nl of .com.",
  "domainError.too_long": "Deze domeinnaam is te lang (maximaal 253 tekens).",
  "domainError.empty_label": "Er staan twee punten achter elkaar of aan het begin.",
  "domainError.label_too_long": "Elk deel tussen de punten mag maximaal 63 tekens zijn.",
  "domainError.tld": "Deze extensie is ongeldig.",
  "domainError.chars": "Gebruik alleen letters, cijfers en koppeltekens.",
  "domainError.hyphen": "Een domeinnaam mag niet beginnen of eindigen met een koppelteken.",
  "lang.label": "Taal",
  "domainsPage.loadError": "Domeinen konden niet worden geladen",
  "domainsPage.notFound": "Domein niet gevonden",
  "domainsPage.search": "Zoek domein…",
  "domainsPage.filter.pending": "In behandeling",
  "domainsPage.dnsPick.title": "DNS-record toevoegen",
  "domainsPage.dnsPick.none": "Je hebt nog geen domeinen. Voeg eerst een domein toe.",
  "domainsPage.dnsPick.choose": "Kies hieronder het domein waarvoor je een record wilt toevoegen.",
  "domainsPage.dismiss": "Sluiten",
  "domainsPage.empty": "Geen domeinen gevonden.",
  "domainsPage.notLinked": "Niet gekoppeld",
  "domainsPage.autoRenew.on": "Automatisch verlengen aan",
  "domainsPage.autoRenew.off": "Automatisch verlengen uit",
  "domainsPage.status.active": "Actief",
  "domainsPage.status.pending": "In behandeling",
  "domainsPage.status.transferring": "Verhuist",
  "domainsPage.status.expired": "Verlopen",
  "domainsPage.status.suspended": "Opgeschort",
  "domainsPage.status.cancelled": "Geannuleerd",
  "domainsPage.status.unknown": "Onbekend",
  "domainsPage.days.expired": "verlopen",
  "domainsPage.days.today": "vandaag",
  "domainsPage.days.one": "over 1 dag",
  "domainsPage.days.other": "over {n} dagen",
  "addDomain.duplicate": "Dit domein staat al in je account.",
  "addDomain.requested": "{domain} is aangevraagd",
  "addDomain.exists": "Dit domein is al geregistreerd in ons systeem.",
  "addDomain.confirm.title": "Registratie bevestigen",
  "addDomain.confirm.description": "Controleer de gegevens. Na bevestigen wordt de registratie aangevraagd.",
  "addDomain.back": "Terug",
  "addDomain.working": "Bezig…",
  "addDomain.register": "Domein registreren",
  "addDomain.term": "Looptijd",
  "addDomain.cost": "Kosten",
  "addDomain.cost.value": "Volgens het geldende tarief voor {tld}; het bedrag staat op je volgende factuur.",
  "addDomain.next": "Volgende",
  "addDomain.name": "Domeinnaam",
  "addDomain.name.hint": "De volledige domeinnaam inclusief extensie (.nl, .com, .eu, …).",
  "addDomain.name.placeholder": "voorbeeld.nl",
  "emailList.domains.one": "{n} domein",
  "emailList.domains.other": "{n} domeinen",
  "emailList.kpi.allocated": "totaal toegewezen",
  "emailList.kpi.noMetric": "Geen meting",
  "emailList.search": "Zoek mailbox…",
  "emailList.group.byDomain": "Per domein",
  "emailList.group.flat": "Alles",
  "emailList.loadError": "Mailboxen konden niet worden geladen",
  "emailList.empty.title": "Nog geen mailboxen",
  "emailList.empty.body": "Maak je eerste mailbox aan.",
  "emailList.noResults.title": "Geen mailboxen gevonden",
  "emailList.noResults.body": "Pas je zoekopdracht of filter aan.",
  "emailList.addresses.one": "{n} adres",
  "emailList.addresses.other": "{n} adressen",
  "emailList.status.suspended": "Opgeschort",
  "emailList.status.pending": "In behandeling",
  "emailList.status.disabled": "Uitgeschakeld",
  "emailList.new.localError": "Gebruik vóór de @ alleen letters, cijfers en . _ - + (niet aan het begin of eind).",
  "mailDomain.add": "E-maildomein toevoegen",
  "mailDomain.description": "Kies een domein of hostingpakket van je account. Wij zetten de mailserver en de DNS-records (MX, SPF, DKIM, DMARC) voor je klaar.",
  "mailDomain.activate": "E-mail activeren",
  "mailDomain.stop": "E-mail uitzetten",
  "mailDomain.stopHint": "Zet je e-mail bij ons uit om naar een andere mailprovider te gaan.",
  "mailDomain.stopTitle": "E-mail voor {domain} uitzetten?",
  "mailDomain.stopBody": "Alle {n} mailboxen, aliassen en hun berichten worden definitief verwijderd, en de mailrecords (MX, SPF, DKIM) gaan uit de DNS. Dit kan niet ongedaan worden gemaakt.",
  "mailDomain.stopped": "E-mail voor {domain} is uitgezet.",
  "mailDomain.activated": "E-mail geactiveerd voor {domain}",
  "mailDomain.none": "Er is geen domein zonder e-mail. Voeg eerst een domein of hostingpakket toe.",
  "mailDomain.firstActivate": "Je hebt nog geen e-maildomein.",
  "mailDomain.routingHint": "Wil je mailboxen op dit domein bij ons? Activeer e-mail, dan zetten we de mailserver en de DNS-records voor je klaar.",
  "mailDomain.err.notOwned": "Dit domein staat niet op je account. Voeg het domein of een hostingpakket ervoor eerst toe.",
  "mailDomain.err.exists": "Voor dit domein is e-mail al actief.",
  "emailList.new.chooseDomain": "— Kies domein —",
  "emailList.new.username": "Gebruikersnaam (vóór @)",
  "emailList.new.quota": "Quota (MB)",
  "emailDetail.working": "Bezig…",
  "emailDetail.create": "Aanmaken",
  "emailDetail.delete": "Verwijderen",
  "emailDetail.change": "Wijzigen",
  "emailDetail.off": "Uit",
  "emailDetail.notFound": "Mailbox niet gevonden",
  "emailDetail.quota": "Opslagruimte",
  "emailDetail.forward.keepCopy": "{address} (kopie bewaren)",
  "emailDetail.client.title": "Instellingen voor je mailprogramma",
  "emailDetail.client.unavailable": "Servergegevens zijn nog niet beschikbaar voor dit domein.",
  "emailDetail.pw.min": "Minimaal 12 tekens.",
  "emailDetail.pw.mismatch": "Wachtwoorden komen niet overeen.",
  "emailDetail.forward.saved": "Doorsturen opgeslagen",
  "emailDetail.forward.desc": "Stuur inkomende mail door naar een ander adres.",
  "emailDetail.forward.on": "Doorsturen aan",
  "emailDetail.forward.to": "Doorsturen naar",
  "emailDetail.invalidEmail": "Geen geldig e-mailadres.",
  "emailDetail.forward.placeholder": "naam@voorbeeld.nl",
  "emailDetail.forward.keep": "Houd een kopie in deze mailbox",
  "emailDetail.vacation.defaultSubject": "Afwezig",
  "emailDetail.vacation.saved": "Afwezigheidsbericht opgeslagen",
  "emailDetail.vacation.title": "Afwezigheidsbericht",
  "emailDetail.vacation.desc": "Stuur automatisch een reactie tijdens een vakantie of afwezigheid.",
  "emailDetail.vacation.on": "Afwezigheidsbericht aan",
  "emailDetail.vacation.placeholder": "Bijvoorbeeld: ik ben afwezig tot en met maandag en reageer daarna zo snel mogelijk.",
  "emailDetail.aliases.desc": "Extra adressen die naar deze mailbox afleveren.",
  "emailDetail.aliases.empty.title": "Nog geen aliassen",
  "emailDetail.aliases.empty.body": "Maak bijvoorbeeld info@ of contact@ als alias voor deze mailbox.",
  "emailDetail.aliases.deleteAria": "Verwijder {address}",
  "emailDetail.aliases.added": "Alias toegevoegd",
  "emailDetail.aliases.deleted": "Alias verwijderd",
  "emailDetail.aliases.confirmTitle": "Alias verwijderen?",
  "emailDetail.aliases.confirmBody": "Mail naar {address} komt daarna niet meer aan.",
  "emailDetail.aliasModal.deliversTo": "Inkomende mail komt aan bij {address}",
  "emailDetail.aliasModal.label": "Alias (deel vóór @)",
  "emailDetail.aliasModal.name": "naam",
  "emailDetail.aliasModal.invalid": "Alleen letters, cijfers en . _ + -",
  "emailDetail.quota.saved": "Opslagruimte aangepast",
  "emailDetail.quota.title": "Opslagruimte",
  "emailDetail.quota.desc": "Maximale ruimte voor deze mailbox.",
  "emailDetail.danger.title": "Gevarenzone",
  "emailDetail.danger.desc": "Het verwijderen van een mailbox is definitief. Alle mail en instellingen gaan verloren.",
  "emailDetail.danger.confirmBody": "Weet je zeker dat je {address} permanent wilt verwijderen?",
  "emailDetail.deleted": "Mailbox verwijderd",
  "emailDetail.spam.saved": "Spamfilter opgeslagen",
  "emailDetail.spam.lenient": "Mild",
  "emailDetail.spam.desc": "Hoe streng moet het spamfilter zijn?",
  "dashboard.greeting.night": "Goedenacht",
  "dashboard.greeting.night.named": "Goedenacht, {name}",
  "dashboard.greeting.morning": "Goedemorgen",
  "dashboard.greeting.morning.named": "Goedemorgen, {name}",
  "dashboard.greeting.afternoon": "Goedemiddag",
  "dashboard.greeting.afternoon.named": "Goedemiddag, {name}",
  "dashboard.greeting.evening": "Goedenavond",
  "dashboard.greeting.evening.named": "Goedenavond, {name}",
  "dashboard.sites.error": "Kon je websites niet laden",
  "dashboard.sites.empty": "Nog geen hosting",
  "dashboard.sites.empty.body": "Bestel een hostingpakket om te beginnen.",
  "dashboard.usage.none": "Nog geen meting",
  "dashboard.activity.empty": "Nog geen activiteit.",
  "detailUi.working": "Bezig…",
  "detailUi.notFound": "Niet gevonden",
  "detailUi.loadFailed": "Laden mislukt",
  "detailUi.retry": "Opnieuw proberen",
  "newPlan.title": "Nieuw hostingpakket",
  "newPlan.description": "Kies een pakket en koppel een domein.",
  "newPlan.created": "Hosting aangemaakt",
  "newPlan.create": "Aanmaken",
  "newPlan.packages.error": "Pakketten konden niet worden geladen. {error}",
  "newPlan.domain.placeholder": "voorbeeld.nl",
  "newPlan.package": "Pakket",
  "newPlan.packages.loading": "Pakketten laden…",
  "newPlan.package.choose": "— Kies een pakket —",
  "hostingList.onServers.one": "op {n} server",
  "hostingList.onServers.other": "op {n} servers",
  "hostingList.storage.allocated": "totaal toegewezen",
  "hostingList.traffic.none": "geen meting",
  "hostingList.error": "Hosting kon niet worden geladen",
  "hostingList.empty": "Geen hosting",
  "hostingList.empty.body": "Voeg je eerste pakket toe om te starten.",
  "hostingList.servers.none": "Geen serverinformatie beschikbaar.",
  "hostingList.sites.one": "{n} site",
  "hostingList.sites.other": "{n} sites",
  "hostingList.addPlanFirst": "Voeg eerst een pakket toe",
  "hostingList.serverStatus.online": "Online",
  "hostingList.serverStatus.offline": "Offline",
  "hostingList.serverStatus.provisioning": "Wordt ingericht",
  "hostingList.serverStatus.error": "Storing",
  "hostingDetail.notFound": "Hosting niet gevonden",
  "hostingDetail.tab.access": "SFTP-toegang",
  "hostingDetail.ssl.settingUp": "SSL wordt ingesteld",
  "hostingDetail.price": "Prijs",
  "hostingDetail.storage": "Opslag",
  "hostingDetail.memory": "Geheugen",
  "hostingDetail.runtime": "Omgeving",
  "hostingDetail.addons": "Add-ons",
  "hostingDetail.created": "Aangemaakt",
  "hostingDetail.nextInvoice": "Volgende factuur",
  "hostingDetail.lastChanged": "Laatst gewijzigd",
  "hostingDetail.ssl.provider": "Provider",
  "hostingDetail.ssl.status": "Status",
  "hostingDetail.ssl.active": "Actief",
  "hostingDetail.ssl.inactive": "Niet actief",
  "hostingDetail.ssl.enable": "SSL activeren",
  "hostingDetail.ssl.selfsigned": "Tijdelijk certificaat",
  "hostingDetail.ssl.temporary": "Tijdelijk — browsers tonen een waarschuwing",
  "hostingDetail.ssl.selfsignedHint": "Zodra je domein naar deze server wijst, plaatsen we automatisch een gratis Let's Encrypt-certificaat.",
  "hostingDetail.copied": "Gekopieerd",
  "hostingDetail.copyFailed": "Kopiëren mislukt",
  "hostingDetail.copy": "Kopieer",
  "hostingDetail.protocol": "Protocol",
  "hostingDetail.sftp.users": "SFTP-gebruikers",
  "hostingDetail.sftp.addUser": "Gebruiker toevoegen",
  "hostingDetail.sftp.limit": "Je pakket heeft het maximum van {max} SFTP-gebruiker(s) bereikt.",
  "hostingDetail.sftp.empty": "Nog geen SFTP-gebruikers.",
  "hostingDetail.sftp.noServer": "Deze hosting heeft nog geen server; SFTP is beschikbaar zodra hij is ingericht.",
  "hostingDetail.sftp.createdOn": "Aangemaakt {date}",
  "hostingDetail.sftp.newPassword": "Nieuw wachtwoord",
  "hostingDetail.delete": "Verwijderen",
  "hostingDetail.sftp.deleteUser": "Verwijder {name}",
  "hostingDetail.sftp.reset.title": "Nieuw wachtwoord genereren?",
  "hostingDetail.sftp.reset.body": "Het huidige wachtwoord van {name} werkt daarna niet meer.",
  "hostingDetail.sftp.reset.cta": "Genereer",
  "hostingDetail.sftp.delete.title": "SFTP-gebruiker verwijderen?",
  "hostingDetail.sftp.delete.body": "{name} kan daarna niet meer inloggen.",
  "hostingDetail.sftp.deleted": "Gebruiker verwijderd",
  "hostingDetail.sftp.add.title": "SFTP-gebruiker toevoegen",
  "hostingDetail.sftp.add.description": "Het wachtwoord wordt één keer getoond na het aanmaken.",
  "hostingDetail.sftp.add.username": "Gebruikersnaam (optioneel)",
  "hostingDetail.sftp.add.usernameHint": "Kleine letters, cijfers, - en _. Leeg laten voor een automatische naam.",
  "hostingDetail.sftp.add.invalid": "Ongeldige gebruikersnaam.",
  "hostingDetail.secret.title": "Bewaar dit wachtwoord",
  "hostingDetail.secret.description": "Het wordt maar één keer getoond.",
  "hostingDetail.secret.done": "Ik heb het bewaard",
  "hostingDetail.user": "Gebruiker",
  "hostingDetail.db.adminer": "Open Adminer",
  "hostingDetail.db.none": "Dit pakket heeft geen database.",
  "hostingDetail.db.type": "Type",
  "hostingDetail.db.database": "Database",
  "hostingDetail.db.host": "Host (vanuit je site)",
  "hostingDetail.db.password": "Wachtwoord",
  "hostingDetail.hide": "Verberg",
  "hostingDetail.show": "Toon",
  "hostingDetail.runtime.current": "Huidige omgeving",
  "hostingDetail.runtime.change": "Een andere versie nodig? Neem contact op met support; wij zetten hem voor je om.",
  "hostingDetail.cancel.pendingUntil": "Opgezegd. De hosting loopt door tot {date}.",
  "hostingDetail.cancel.pendingEndOfPeriod": "Opgezegd. De hosting loopt door tot het einde van de periode.",
  "hostingDetail.cancel.info": "Opzeggen gaat in per einde van de lopende periode. Daarna worden alle bestanden verwijderd.",
  "hostingDetail.revoke.button": "Opzegging intrekken",
  "hostingDetail.restart.title": "Hosting herstarten?",
  "hostingDetail.restart.started": "Herstart gestart",
  "hostingDetail.cancel.title": "Hosting opzeggen?",
  "hostingDetail.cancel.body": "Weet je zeker dat je {domain} wilt opzeggen?",
  "hostingDetail.cancel.submitted": "Opzegging ingediend",
  "hostingDetail.revoke.title": "Opzegging intrekken?",
  "hostingDetail.revoke.body": "De hosting loopt dan gewoon door.",
  "hostingDetail.revoke.cta": "Intrekken",
  "hostingDetail.revoke.done": "Opzegging ingetrokken",
  "billingPage.noPaymentLink": "Geen betaallink ontvangen. Probeer het later opnieuw.",
  "billingPage.mandate.loadFailed": "kon niet worden geladen",
  "billingPage.mandate.none": "niets ingesteld",
  "billingPage.openCount.one": "{n} factuur",
  "billingPage.openCount.other": "{n} facturen",
  "billingPage.allPaid": "niets openstaand",
  "billingPage.inclVat": "incl. btw",
  "billingPage.next.approx": "ca. {amount}",
  "billingPage.next.none": "geen lopende abonnementen",
  "billingPage.sepa.enabled": "SEPA-incasso staat aan",
  "billingPage.sepa.body": "Facturen worden automatisch geïncasseerd op de vervaldatum.",
  "billingPage.revoke.cta": "Machtiging intrekken",
  "billingPage.noInvoices": "Geen facturen.",
  "billingPage.renews": "verlengt {date}",
  "billingPage.noSubscriptions": "Geen abonnementen.",
  "billingPage.add": "Toevoegen",
  "billingPage.method.loadFailed": "Je betaalmethode kon niet worden opgehaald.",
  "billingPage.retry": "Opnieuw proberen",
  "billingPage.method.none": "Geen betaalmethode ingesteld.",
  "billingPage.mandateStatus.valid": "actief",
  "billingPage.mandateStatus.pending": "in behandeling",
  "billingPage.mandateStatus.invalid": "ongeldig",
  "billingPage.mandateStatus.revoked": "ingetrokken",
  "billingPage.revoke.done": "Machtiging ingetrokken",
  "billingPage.revoke.title": "SEPA-machtiging intrekken?",
  "billingPage.revoke.body": "Facturen worden daarna niet meer automatisch geïncasseerd. Je betaalt ze dan zelf via de factuurpagina.",
  "billingPage.working": "Bezig…",
  "billingPage.revoke.confirm": "Intrekken",
  "billingDetail.notFound": "Factuur niet gevonden",
  "billingDetail.loadFailed": "Factuur kon niet worden geladen",
  "billingDetail.notFound.body": "Deze factuur bestaat niet of hoort niet bij jouw account.",
  "billingDetail.downloadFailed": "Download mislukt",
  "billingDetail.title": "Factuur {number}",
  "billingDetail.due": "Vervalt {date}",
  "billingDetail.print": "Afdrukken",
  "billingDetail.payNow": "Nu betalen",
  "billingDetail.items": "Specificatie",
  "billingDetail.hostingPlan": "Hosting {plan}",
  "billingDetail.hostingId": "Hosting #{id}",
  "billingDetail.services": "Diensten",
  "billingDetail.invoiceDate": "Factuurdatum",
  "billingDetail.vat": "Btw",
  "billingDetail.vatPct": "Btw ({pct}%)",
  "billingDetail.pdfNote": "De volledige specificatie staat in de PDF.",
  "billingDetail.billedTo": "Gefactureerd aan",
  "billingDetail.addressNote": "Het volledige factuuradres staat op de PDF. Klopt er iets niet? Neem contact met ons op.",
  "billingDetail.history": "Geschiedenis",
  "billingDetail.hist.created": "Factuur aangemaakt",
  "billingDetail.hist.overdue": "Vervaldatum verstreken",
  "billingDetail.hist.cancelled": "Factuur geannuleerd",
  "billingDetail.hist.paid": "Betaling ontvangen",
  "billingDetail.pay.title": "Factuur betalen",
  "billingDetail.pay.cta": "Naar betalen",
  "billingDetail.pay.choose": "Kies een betaalmethode",
  "billingDetail.method.any": "Kies bij de betaalpagina",
  "billingDetail.method.any.sub": "Alle beschikbare betaalmethoden",
  "billingDetail.method.ideal": "iDEAL",
  "billingDetail.method.ideal.sub": "Betaal direct via je bank",
  "billingDetail.method.creditcard": "Creditcard",
  "billingDetail.method.creditcard.sub": "Mastercard / Visa / Amex",
  "backupsPage.automatic": "Automatisch",
  "backupsPage.kpi.lastSub": "laatste geslaagde backup",
  "backupsPage.kpi.lastNone": "nog geen backups",
  "backupsPage.kpi.successSub": "geslaagd van afgeronde backups",
  "backupsPage.kpi.storageSub": "totaal in bewaarde backups",
  "backupsPage.days.one": "{n} dag",
  "backupsPage.days.other": "{n} dagen",
  "backupsPage.kpi.retentionSub": "maximaal",
  "backupsPage.noHostings": "Geen hostings gevonden.",
  "backupsPage.every": "Iedere {h}u",
  "backupsPage.failed": "Mislukt",
  "backupsPage.noBackup": "Nog geen backup",
  "backupsPage.off": "Uit",
  "backupsDetail.notFound": "Hosting niet gevonden",
  "backupsDetail.autoOff": "Automatische backups uit",
  "backupsDetail.lastFailed": "Laatste backup mislukt",
  "backupsDetail.snapshots.one": "{n} snapshot",
  "backupsDetail.snapshots.other": "{n} snapshots",
  "backupsDetail.last": "laatste {time}",
  "backupsDetail.onlyActive": "Alleen voor actieve hostings",
  "backupsDetail.running": "Backup loopt…",
  "backupsDetail.tab.schedule": "Schema",
  "backupsDetail.create.title": "Nu een backup maken?",
  "backupsDetail.create.body": "De backup draait op de achtergrond; dit kan enkele minuten duren.",
  "backupsDetail.create.cta": "Start backup",
  "backupsDetail.create.done": "Backup gestart",
  "backupsDetail.restore.title": "Backup terugzetten?",
  "backupsDetail.restore.body": "De huidige bestanden en database van {domain} worden vervangen door de backup van {date}. Dit kan niet ongedaan worden gemaakt.",
  "backupsDetail.restore.cta": "Terugzetten",
  "backupsDetail.restore.done": "Terugzetten gestart",
  "backupsDetail.pickSnapshot": "Kies een voltooide snapshot om terug te zetten.",
  "backupsDetail.empty.title": "Nog geen backups",
  "backupsDetail.empty.body": "De eerste automatische backup verschijnt hier zodra hij gemaakt is.",
  "backupsDetail.col.time": "Tijdstip",
  "backupsDetail.col.keptUntil": "Bewaard tot",
  "backupsDetail.type.full": "Automatisch",
  "backupsDetail.type.incremental": "Incrementeel",
  "backupsDetail.type.manual": "Handmatig",
  "backupsDetail.status.pending": "In wachtrij",
  "backupsDetail.status.running": "Bezig",
  "backupsDetail.status.completed": "Voltooid",
  "backupsDetail.status.failed": "Mislukt",
  "backupsDetail.saved": "Backupschema opgeslagen",
  "backupsDetail.auto.title": "Automatische backups",
  "backupsDetail.auto.toggle": "Automatisch backups maken",
  "backupsDetail.frequency": "Frequentie",
  "backupsDetail.everyHours": "Elke {n} uur",
  "backupsDetail.keepFor": "Bewaren",
  "backupsDetail.retention": "Bewaartermijn",
  "backupsDetail.working": "Bezig…",
  "dashboard.activity.verb.create": "{resource} aangemaakt",
  "dashboard.activity.verb.update": "{resource} gewijzigd",
  "dashboard.activity.verb.delete": "{resource} verwijderd",
  "dashboard.activity.verb.restore": "{resource} teruggezet",
  "dashboard.activity.verb.suspend": "{resource} opgeschort",
  "dashboard.activity.verb.unsuspend": "{resource} heractiveerd",
  "dashboard.activity.verb.register": "{resource} geregistreerd",
  "dashboard.activity.verb.cancel": "{resource} opgezegd",
  "dashboard.activity.verb.renew": "{resource} verlengd",
  "dashboard.activity.verb.pay": "{resource} betaald",
  "dashboard.activity.resource.hosting": "Hosting",
  "dashboard.activity.resource.backup": "Backup",
  "dashboard.activity.resource.domain": "Domein",
  "dashboard.activity.resource.dns": "DNS-record",
  "dashboard.activity.resource.email": "E-mail",
  "dashboard.activity.resource.invoice": "Factuur",
  "dashboard.activity.resource.payment": "Betaling",
  "dashboard.activity.resource.user": "Account",
  "dashboard.activity.resource.server": "Server",
  "dashboard.activity.resource.package": "Pakket",
  "domainDetail.allDomains": "Alle domeinen",
  "domainDetail.expiresIn.one": " · over {n} dag",
  "domainDetail.expiresIn.other": " · over {n} dagen",
  "domainDetail.autoRenewState.on": "Automatisch verlengen: aan",
  "domainDetail.autoRenewState.off": "Automatisch verlengen: uit",
  "domainDetail.status.active": "Actief",
  "domainDetail.status.pending": "In behandeling",
  "domainDetail.status.transferring": "Verhuist",
  "domainDetail.status.expired": "Verlopen",
  "domainDetail.status.suspended": "Opgeschort",
  "domainDetail.status.unknown": "Onbekend",
  "domainDetail.registration": "Registratie",
  "domainDetail.autoRenew": "Automatisch verlengen",
  "domainDetail.on": "Aan",
  "domainDetail.off": "Uit",
  "domainDetail.nameservers": "Nameservers",
  "domainDetail.linkedServices": "Gekoppelde diensten",
  "domainDetail.webHosting": "Webhosting",
  "domainDetail.emailService.one": "E-mail ({n} mailbox)",
  "domainDetail.emailService.other": "E-mail ({n} mailboxen)",
  "domainDetail.notLinked": "Dit domein is nog niet aan hosting of e-mail gekoppeld.",
  "domainDetail.openService": "{name} openen",
  "domainDetail.dns.simpleTitle": "Wat wil je doen?",
  "domainDetail.dns.allRecords": "Alle DNS-records",
  "domainDetail.dns.simpleSub": "Kies een veelvoorkomende taak en wij regelen de DNS-records voor je.",
  "domainDetail.dns.advancedSub": "Niet zeker? Gebruik de simpele modus.",
  "domainDetail.dns.mode": "DNS-modus",
  "domainDetail.dns.simple": "Simpele modus",
  "domainDetail.dns.advanced": "Geavanceerd",
  "domainDetail.task.website.desc": "Stel A- en CNAME-records in zodat bezoekers op je website terechtkomen.",
  "domainDetail.task.mail.title": "Mijn e-mail loopt via…",
  "domainDetail.task.mail.desc": "Configureer MX-records voor je mailprovider.",
  "domainDetail.task.verify.title": "Verifieer een dienst",
  "domainDetail.task.verify.desc": "Plaats een TXT-record om eigendom aan te tonen (Google, Meta, …).",
  "domainDetail.task.forward.title": "Stuur naar een andere URL",
  "domainDetail.task.forward.desc": "Stuur bezoekers van dit domein door naar een ander adres.",
  "domainDetail.records.one": "{n} record",
  "domainDetail.records.other": "{n} records",
  "domainDetail.addRecord": "Record toevoegen",
  "domainDetail.noRecords": "Nog geen DNS-records",
  "domainDetail.noRecords.sub": "Voeg een record toe of gebruik de simpele modus.",
  "domainDetail.col.type": "Type",
  "domainDetail.name": "Naam",
  "domainDetail.edit": "Bewerk",
  "domainDetail.editRecord": "Bewerk {type} {name}",
  "domainDetail.err.value": "Vul een waarde in.",
  "domainDetail.err.ipv4": "Geen geldig IPv4-adres.",
  "domainDetail.err.ipv6": "Geen geldig IPv6-adres.",
  "domainDetail.err.hostname": "Geen geldige hostnaam.",
  "domainDetail.err.priority": "Vul een prioriteit in.",
  "domainDetail.recordAdded": "Record toegevoegd",
  "domainDetail.recordSaved": "Record opgeslagen",
  "domainDetail.deleteRecord.title": "Record verwijderen?",
  "domainDetail.delete": "Verwijderen",
  "domainDetail.recordDeleted": "Record verwijderd",
  "domainDetail.addDnsRecord": "DNS-record toevoegen",
  "domainDetail.editDnsRecord": "DNS-record bewerken",
  "domainDetail.propagation": "Wijzigingen kunnen tot 1 uur duren voor ze wereldwijd zichtbaar zijn.",
  "domainDetail.working": "Bezig…",
  "domainDetail.typeFixed": "Het type kan niet worden gewijzigd.",
  "domainDetail.ttlSeconds": "TTL (seconden)",
  "domainDetail.name.hint": "Gebruik @ voor {domain}, of bijv. www of mail.",
  "domainDetail.err.name": "Vul een naam in.",
  "domainDetail.priority.hint": "Lager = belangrijker.",
  "domainDetail.replaced.one": "{n} bestaand record wordt vervangen.",
  "domainDetail.replaced.other": "{n} bestaande records worden vervangen.",
  "domainDetail.website.desc": "Kies waar je website draait. Wij zetten de juiste DNS-records.",
  "domainDetail.recordsApplied": "Records ingesteld",
  "domainDetail.website.where": "Waar draait je website?",
  "domainDetail.website.ip": "Een IP-adres",
  "domainDetail.website.ip.sub": "Je hostingpartij geeft je een IPv4-adres.",
  "domainDetail.website.host": "Een hostnaam (bijv. mijnsite.netlify.app)",
  "domainDetail.website.host.sub": "Voor diensten als Netlify, Vercel of Shopify. Geldt voor www.",
  "domainDetail.ipAddress": "IP-adres",
  "domainDetail.hostname": "Hostnaam",
  "domainDetail.preview.set": "Wij zetten deze records:",
  "domainDetail.mail.ours": "Onze mailservice",
  "domainDetail.mail.ours.desc": "Mailboxen beheer je hier in het portaal ({n} actief).",
  "domainDetail.mail.google.desc": "Gmail voor je domein. Je hebt een Workspace-account nodig.",
  "domainDetail.mail.ms.desc": "Outlook voor je domein. Je hebt een Microsoft 365-account nodig.",
  "domainDetail.mail.custom": "Andere provider",
  "domainDetail.mail.custom.desc": "Vul de mailserver van je provider in.",
  "domainDetail.mail.none": "Geen e-mail",
  "domainDetail.mail.none.desc": "Geen e-mail op dit domein. Verwijdert de MX-records.",
  "domainDetail.mail.desc": "Kies je e-mailprovider. Wij vervangen de MX-records.",
  "domainDetail.mail.cta": "MX-records vervangen",
  "domainDetail.mail.applied": "MX-records ingesteld",
  "domainDetail.mail.provider": "Mailprovider",
  "domainDetail.mail.server": "Mailserver",
  "domainDetail.preview.mxRemoved": "Alle MX-records worden verwijderd.",
  "domainDetail.verify.desc": "Veel diensten vragen een TXT-record om aan te tonen dat dit domein van jou is.",
  "domainDetail.verify.cta": "TXT-record aanmaken",
  "domainDetail.verify.created": "TXT-record aangemaakt",
  "domainDetail.verify.code": "Verificatiecode",
  "domainDetail.verify.code.hint": "Begint meestal met bijv. google-site-verification=",
  "domainDetail.preview.create": "Wij maken dit record aan:",
  "domainDetail.redirect.desc": "Bezoekers worden automatisch doorgestuurd naar het adres dat je invult.",
  "domainDetail.create": "Aanmaken",
  "domainDetail.redirect.created": "Doorsturing aangemaakt",
  "domainDetail.redirect.from": "Van",
  "domainDetail.redirect.from.hint": "@ voor {domain}, of een subdomein zoals shop.",
  "domainDetail.redirect.from.err": "Gebruik @ of een geldig subdomein.",
  "domainDetail.redirect.to": "Naar (volledige URL)",
  "domainDetail.redirect.to.err": "Vul een volledige URL in, beginnend met https://",
  "domainDetail.redirect.type": "Type doorsturing",
  "domainDetail.redirect.301": "301 — permanent",
  "domainDetail.redirect.302": "302 — tijdelijk",
  "domainDetail.redirect.keepPath": "Pad meenemen (/pagina → doel/pagina)",
  "domainDetail.routing.title": "Huidige mailrouting",
  "domainDetail.routing.change": "Wijzig provider",
  "domainDetail.routing.none": "Geen e-mail ingesteld",
  "domainDetail.routing.noMx": "Er staan geen MX-records voor dit domein.",
  "domainDetail.deliverability": "Bezorgbaarheid",
  "domainDetail.spf.missing": "Geen SPF-record gevonden. Ontvangers kunnen je mail als spam zien.",
  "domainDetail.dkim.missing": "Geen DKIM-record gevonden.",
  "domainDetail.dmarc.policy": "Beleid: {policy}",
  "domainDetail.dmarc.missing": "Geen DMARC-record gevonden. Aanbevolen: p=quarantine.",
  "domainDetail.forwards": "Doorsturingen",
  "domainDetail.add": "Toevoegen",
  "domainDetail.forwards.empty": "Geen doorsturingen",
  "domainDetail.forwards.empty.sub": "Stuur (een subdomein van) dit domein door naar een ander adres.",
  "domainDetail.forward.temporary": "Tijdelijk",
  "domainDetail.forward.permanent": "Permanent",
  "domainDetail.forward.frame": "Frame",
  "domainDetail.forward.delete": "Verwijder doorsturing {from}",
  "domainDetail.forward.delete.title": "Doorsturing verwijderen?",
  "domainDetail.forward.deleted": "Doorsturing verwijderd",
  "domainDetail.ns.saved": "Nameservers opgeslagen",
  "domainDetail.ns.desc": "De nameservers bepalen wie de DNS van dit domein beheert. Kies onze nameservers (wij beheren de zone) of je eigen.",
  "domainDetail.ns.label": "Nameserver {n}",
  "domainDetail.ns.invalid": "Een of meer nameservers zijn geen geldige hostnaam.",
  "domainDetail.dnssec.enabled": "DNSSEC aangezet",
  "domainDetail.dnssec.disabled": "DNSSEC uitgezet",
  "domainDetail.dnssec.desc": "DNSSEC zorgt dat antwoorden op DNS-vragen cryptografisch ondertekend zijn. Aanrader voor productiedomeinen.",
  "domainDetail.dnssec.changed": "Gewijzigd {date}",
  "topbar.search.goToPage": "Ga naar pagina",
  "topbar.search.action": "Actie",
  "topbar.action.addDomain": "Domein toevoegen",
  "topbar.action.createMailbox": "Mailbox aanmaken",
  "topbar.action.addDnsRecord": "DNS-record toevoegen",
  "topbar.action.restoreBackup": "Backup terugzetten",
  "topbar.action.newPlan": "Nieuw hostingpakket",
  "topbar.action.openInvoices": "Open facturen",
  "topbar.menu.open": "Menu openen",
  "topbar.menu.close": "Menu sluiten",
  "topbar.menu.label": "Menu",
  "topbar.menu.main": "Hoofdmenu",
  "topbar.search.title": "Zoek (⌘K)",
  "topbar.search.label": "Zoeken",
  "topbar.search.placeholder": "Zoek…",
  "topbar.search.pages": "Pagina's",
  "topbar.search.actions": "Acties",
  "topbar.search.inputLabel": "Zoek pagina of actie",
  "topbar.search.inputPlaceholder": "Zoek pagina of actie…",
  "topbar.search.noResults": "Geen resultaten voor \"{q}\"",
  "topbar.search.navigate": "navigeer",
  "topbar.search.open": "openen",
  "topbar.search.close": "sluit",
  "topbar.notif.title": "Meldingen",
  "topbar.notif.labelUnread": "Meldingen, {n} ongelezen",
  "topbar.notif.unread": "{n} ongelezen",
  "topbar.notif.allCaughtUp": "Alles bijgewerkt",
  "topbar.notif.markAllRead": "Alles gelezen",
  "topbar.notif.loadError": "Meldingen konden niet worden geladen.",
  "topbar.notif.empty": "Geen meldingen",
  "topbar.theme.toggle": "Thema wisselen",
  "topbar.user.menu": "Accountmenu",
  "topbar.user.idCopied": "Klantnummer gekopieerd",
  "topbar.user.customer": "Klant",
  "topbar.user.copy": "Kopieer",
  "topbar.user.copyId": "Klantnummer kopiëren",
  "topbar.user.darkTheme": "Donker thema",
  "account.title": "Mijn account",
  "account.working": "Bezig…",
  "account.close": "Sluiten",
  "account.change": "Wijzigen",
  "account.enable": "Inschakelen",
  "account.disable": "Uitschakelen",
  "account.continue": "Doorgaan",
  "account.copied": "Gekopieerd",
  "account.password": "Wachtwoord",
  "account.currentPassword": "Huidig wachtwoord",
  "account.logout.menu": "Uitloggen",
  "account.logout.title": "Uitloggen?",
  "account.logout.body": "Je wordt afgemeld op dit apparaat. Aangemelde mailclients en SSH-sessies blijven actief.",
  "account.logout.cta": "Ja, log uit",
  "account.logout.done": "Je bent uitgelogd",
  "account.profile.saved": "Profiel opgeslagen",
  "account.profile.fullName": "Volledige naam",
  "account.profile.email": "E-mailadres",
  "account.profile.currentPasswordHint": "Nodig om je e-mailadres te wijzigen.",
  "account.security.title": "Beveiliging & 2FA",
  "account.security.description": "Beheer je wachtwoord en tweestapsverificatie.",
  "account.security.passwordSub": "Wijzig het wachtwoord waarmee je inlogt.",
  "account.security.mfa": "Tweestapsverificatie",
  "account.security.mfaActive": "Actief — authenticator-app",
  "account.security.mfaOff": "Niet ingeschakeld",
  "account.password.min": "Minimaal {n} tekens.",
  "account.password.mismatch": "Wachtwoorden komen niet overeen.",
  "account.password.changed": "Wachtwoord gewijzigd",
  "account.password.wrongCurrent": "Je huidige wachtwoord klopt niet.",
  "account.password.changeTitle": "Wachtwoord wijzigen",
  "account.password.new": "Nieuw wachtwoord",
  "account.password.confirm": "Bevestig nieuw wachtwoord",
  "account.mfa.enabledTitle": "2FA is ingeschakeld",
  "account.mfa.recoveryBody": "Bewaar deze herstelcodes op een veilige plek. Elke code werkt één keer als je je telefoon niet bij de hand hebt.",
  "account.mfa.saved": "Ik heb ze bewaard",
  "account.mfa.enableTitle": "Tweestapsverificatie inschakelen",
  "account.mfa.setupBody": "Voeg dit account toe in je authenticator-app (bijv. 1Password, Google Authenticator) met de sleutel hieronder, en vul daarna de code van 6 cijfers in.",
  "account.mfa.introBody": "Na het inschakelen vragen we bij het inloggen ook om een code uit je authenticator-app.",
  "account.mfa.key": "Sleutel",
  "account.mfa.openInApp": "Openen in authenticator-app",
  "account.mfa.copyKey": "Kopieer sleutel",
  "account.mfa.codeFromApp": "Code uit de app",
  "account.mfa.disabled": "2FA uitgeschakeld",
  "account.mfa.disableTitle": "Tweestapsverificatie uitschakelen",
  "account.mfa.disableBody": "Bevestig met een code uit je authenticator-app.",
  "account.mfa.code": "Code",
  "login.title": "Welkom terug",
  "login.subtitle": "Log in om je hosting, domeinen en e-mail te beheren.",
  "login.mfaCode": "Code uit je authenticator-app",
  "login.back": "Terug",
  "login.submit": "Inloggen",
  "login.noAccount": "Nog geen account? Neem contact op.",
  "dashboard.mailboxCount.one": "{n} mailbox",
  "dashboard.mailboxCount.other": "{n} mailboxen",
  "addDomain.description.check": "Controleer of je domein vrij is en registreer het direct.",
  "addDomain.checking": "Controleren…",
  "addDomain.prices": "Prijzen per jaar: {list}",
  "addDomain.term.years.one": "{n} jaar, daarna jaarlijks verlengd",
  "addDomain.term.years.other": "{n} jaar, daarna jaarlijks verlengd",
  "addDomain.cost.price": "{amount}, op je volgende factuur",
  "addDomain.renew": "Verlenging",
  "addDomain.renew.price": "{amount} per jaar",
  "addDomain.status.registered": "{domain} is al geregistreerd. Probeer een andere naam of extensie.",
  "addDomain.status.reserved": "{domain} is gereserveerd en kan niet worden geregistreerd.",
  "addDomain.status.premium": "{domain} is een premiumdomein. Neem contact met ons op voor de mogelijkheden.",
  "addDomain.status.invalid": "Dit is geen geldige domeinnaam.",
  "addDomain.status.unsupported_tld": "Deze extensie bieden we (nog) niet aan.",
  "addDomain.status.unknown": "We konden niet vaststellen of {domain} vrij is. Probeer het later opnieuw.",
  "login.forgot": "Wachtwoord vergeten?",
  "public.toLogin": "Naar inloggen",
  "public.missingToken": "Deze link is onvolledig. Open de link uit de e-mail opnieuw of kopieer hem in zijn geheel.",
  "public.password.new": "Nieuw wachtwoord",
  "public.password.repeat": "Herhaal wachtwoord",
  "public.password.hint": "Minimaal {n} tekens.",
  "public.password.tooShort": "Je wachtwoord moet minimaal {n} tekens lang zijn.",
  "public.password.mismatch": "De wachtwoorden komen niet overeen.",
  "verify.title": "E-mailadres bevestigen",
  "verify.busy": "Je e-mailadres wordt bevestigd…",
  "verify.ok": "Je e-mailadres is bevestigd. Je kunt nu inloggen.",
  "verify.invalid": "Deze bevestigingslink is ongeldig of al gebruikt. Is je adres al bevestigd? Dan kun je gewoon inloggen.",
  "reset.request.title": "Wachtwoord vergeten",
  "reset.request.sub": "Vul je e-mailadres in. We sturen je een link om een nieuw wachtwoord in te stellen.",
  "reset.request.submit": "Stuur herstellink",
  "reset.request.sent": "Als er een account bestaat voor {email}, staat er binnen enkele minuten een link in je mailbox. De link is 1 uur geldig.",
  "reset.title": "Nieuw wachtwoord instellen",
  "reset.sub": "Kies een nieuw wachtwoord voor je account.",
  "reset.submit": "Wachtwoord opslaan",
  "reset.done": "Je wachtwoord is gewijzigd. Log in met je nieuwe wachtwoord.",
  "reset.invalid": "Deze herstellink is ongeldig of verlopen. Vraag een nieuwe aan.",
  "reset.requestNew": "Nieuwe herstellink aanvragen",
  "invite.title": "Uitnodiging accepteren",
  "invite.sub": "Je bent uitgenodigd voor DMRS Console. Vul je naam in en kies een wachtwoord om je account aan te maken.",
  "invite.name": "Volledige naam",
  "invite.submit": "Account aanmaken",
  "invite.done": "Je account is aangemaakt. Je kunt nu inloggen.",
  "invite.done.email": "Je account is aangemaakt. Log in met {email} en je nieuwe wachtwoord.",
  "invite.invalid": "Deze uitnodiging is ongeldig of al gebruikt.",
  "invite.expired": "Deze uitnodiging is verlopen. Vraag degene die je uitnodigde om een nieuwe.",
  "invite.registered": "Voor dit e-mailadres bestaat al een account. Log in of herstel je wachtwoord.",

  "addDomain.order.title": "{domain} bestellen",
  "addDomain.order.description": "Je betaalt via Mollie. Na de betaling registreren we het domein op naam van de houder hieronder.",
  "addDomain.pricePerYear": "Prijs per jaar",
  "addDomain.period.one": "{n} jaar",
  "addDomain.period.other": "{n} jaar",
  "addDomain.period.price.one": "{n} jaar · {amount}",
  "addDomain.period.price.other": "{n} jaar · {amount}",
  "addDomain.vatNote": "Bedragen zijn exclusief 21% btw.",
  "addDomain.pay": "Bestellen en betalen",
  "addDomain.redirecting": "Naar betaling…",
  "addDomain.registered.title": "{domain} is al geregistreerd",
  "addDomain.registered.description": "Is dit jouw domein? Koppel het aan je account of verhuis het naar ons.",
  "addDomain.choice.link": "Ik ben de eigenaar: koppelen",
  "addDomain.choice.link.sub": "Gratis. De registratie blijft bij je huidige provider.",
  "addDomain.choice.transfer": "Verhuizen naar ons",
  "addDomain.choice.transfer.sub": "{amount} excl. btw. Je hebt de verhuiscode van je huidige provider nodig.",
  "addDomain.choice.transfer.unpriced": "Je hebt de verhuiscode van je huidige provider nodig.",
  "addDomain.link": "Domein koppelen",
  "addDomain.linked": "{domain} is gekoppeld",
  "addDomain.authCode": "Verhuiscode (EPP-code)",
  "addDomain.authCode.hint": "Vraag deze code op bij je huidige provider.",
  "registrant.title": "Houder van het domein",
  "registrant.hint": "Deze gegevens worden bij het register vastgelegd.",
  "registrant.name": "Naam",
  "registrant.company": "Bedrijf (optioneel)",
  "registrant.address": "Adres",
  "registrant.postalCode": "Postcode",
  "registrant.city": "Plaats",
  "registrant.country": "Land",
  "registrant.phone": "Telefoon",
  "registrant.phone.hint": "Bijvoorbeeld +31 6 12345678",
  "registrant.email": "E-mail",
  "order.err.required": "Vul dit veld in.",
  "order.err.invalid": "Controleer dit veld.",
  "order.err.fields": "Controleer de gemarkeerde velden.",
  "order.err.notRegistered": "{domain} is niet geregistreerd en kan dus niet verhuisd worden. Registreer het in plaats daarvan.",
  "order.err.alreadyManaged": "{domain} staat al bij ons geregistreerd.",
  "order.err.orderExists": "Er staat al een openstaande bestelling voor {domain}. Je vindt die op de domeinenpagina.",
  "order.err.paymentFailed": "De bestelling is aangemaakt, maar de betaling kon niet starten. Probeer het later opnieuw via de domeinenpagina.",
  "order.err.priceUnavailable": "Deze extensie heeft nog geen prijs en kan nu niet besteld worden. Neem contact met ons op.",
  "orders.title": "Domeinbestellingen",
  "orders.checking": "Status van je bestelling ophalen…",
  "orders.pay": "Betalen",
  "orders.details": "Technische melding",
  "orders.error.invalid_auth_code": "De verhuiscode (EPP) werd geweigerd. Vraag een nieuwe code op bij je huidige provider en probeer het opnieuw.",
  "orders.error.domain_unavailable": "Dit domein is niet (meer) beschikbaar voor registratie.",
  "orders.error.transfer_refused": "De huidige registrar of de registry heeft de verhuizing geweigerd. Controleer of het domein ontgrendeld is.",
  "orders.error.contact_invalid": "De houdergegevens werden niet geaccepteerd. Controleer adres en telefoonnummer.",
  "orders.error.price_unavailable": "Voor deze extensie is nu geen prijs beschikbaar.",
  "orders.error.provider_error": "De registrar kon de bestelling niet verwerken. Ons team is op de hoogte en neemt contact met je op.",
  "orders.err.notPayable": "Deze bestelling kan niet meer betaald worden.",
  "orders.action.register": "Registratie",
  "orders.action.transfer": "Verhuizing",
  "orders.status.pending": "Wacht op betaling",
  "orders.status.paid": "Betaald",
  "orders.status.provisioning": "In behandeling",
  "orders.status.completed": "Afgerond",
  "orders.status.failed": "Mislukt",
  "orders.status.cancelled": "Geannuleerd",
  "orders.msg.pending": "We hebben je betaling nog niet ontvangen.",
  "orders.msg.provisioning.register": "Betaling ontvangen. We registreren het domein nu.",
  "orders.msg.provisioning.transfer": "Betaling ontvangen. We vragen de verhuizing nu aan.",
  "orders.msg.completed.register": "{domain} is geregistreerd en staat in je lijst.",
  "orders.msg.completed.transfer": "De verhuizing van {domain} is aangevraagd. Dit kan enkele dagen duren.",
  "orders.msg.failed": "Het verwerken van {domain} is mislukt. We zijn op de hoogte en nemen contact met je op.",
  "domainDetail.ns.modeDefault": "Standaard",
  "domainDetail.ns.modeOwn": "Eigen nameservers",
  "domainDetail.ns.ownDesc": "Minimaal twee. Met eigen nameservers beheer je de DNS zelf bij je eigen provider; de records hier worden dan niet meer gebruikt.",
  "domainDetail.ns.defaultExplain": "Wij beheren de zone en zetten de nameservers bij de registrar goed. Je records staan klaar voordat dat gebeurt.",
  "domainDetail.ns.registrarPicks": "De zone staat bij onze registrar, die de nameservers zelf kiest.",
  "domainDetail.ns.source.own": "Door jou opgegeven",
  "domainDetail.ns.source.package": "Horen bij je hostingpakket",
  "domainDetail.ns.source.global": "Onze standaard-nameservers",
  "domainDetail.ns.source.bunny": "Onze standaard-nameservers",
  "domainDetail.ns.source.registrar": "Gekozen door de registrar",
  "domainDetail.ns.state.ok": "Ingesteld bij de registrar",
  "domainDetail.ns.state.pending": "Wordt ingesteld bij de registrar",
  "domainDetail.ns.state.other": "Stel deze in bij je eigen registrar",
  "domainDetail.dnssec.enabledPending": "DNSSEC aangezet; de sleutel wordt bij de registry gezet",
  "domainDetail.dnssec.state.off": "DNSSEC staat uit.",
  "domainDetail.dnssec.state.on": "De zone is ondertekend en de sleutel staat bij de registry.",
  "domainDetail.dnssec.state.pending": "De zone is ondertekend. De sleutel wordt zo snel mogelijk bij de registry gezet.",
  "domainDetail.dnssec.state.copyDs": "De zone is ondertekend. Zet dit DS-record bij de registrar van je domein:",
  "domainDetail.dnssec.legacyZone": "Deze zone wordt altijd automatisch ondertekend.",
  "domainDetail.dnssec.ownNameservers": "Met eigen nameservers regel je DNSSEC bij je eigen DNS-provider.",
  "addDomain.prestage": "Alleen voorbereiden",
  "addDomain.prestage.hint": "Voorbereiden: je stelt de DNS nu al in en bestelt de registratie later. Dan werkt het domein meteen.",
  "addDomain.prestaged": "{domain} is voorbereid. Stel de DNS in en bestel de registratie wanneer je wilt.",
};
